import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
  StringOrStringArray: { input: string | string[]; output: string | string[]; }
};

export type AcceptResetPasswordOutputObjectType = {
  __typename?: 'AcceptResetPasswordOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddItemSetQuestionQConfigStructureConditionInput = {
  needTotal: Scalars['Int']['input'];
  tagGroups: Array<AddItemSetQuestionQConfigStructureConditionTagGroupInput>;
};

export type AddItemSetQuestionQConfigStructureConditionTagGroupInput = {
  count: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};

export type AddItemSetQuestionQConfigStructureInput = {
  chapterLevelItemId: Scalars['String']['input'];
  conditions: Array<AddItemSetQuestionQConfigStructureConditionInput>;
  location: AddItemSetQuestionQConfigStructureLocationInput;
  qConfigId: Scalars['String']['input'];
  scorePerQuestion: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type AddItemSetQuestionQConfigStructureLocationInput = {
  locationType: AddItemSetQuestionQConfigStructureLocationType;
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AddItemSetQuestionQConfigStructureLocationType {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export type AddItemSetQuestionQConfigStructureOutput = {
  __typename?: 'AddItemSetQuestionQConfigStructureOutput';
  qConfig: QConfig;
};

export type AddQConfigStructuresInput = {
  qConfigId: Scalars['String']['input'];
  selectedQBankStructureId: Scalars['String']['input'];
  selectedQBankStructureLevelItemIds: Array<Scalars['String']['input']>;
};

export type AddQConfigStructuresOutput = {
  __typename?: 'AddQConfigStructuresOutput';
  qConfig: QConfig;
};

export enum AddQuestionQConfigStructureLocationType {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export type AddSingleQuestionQConfigStructureConditionInput = {
  needTotal: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};

export type AddSingleQuestionQConfigStructureInput = {
  chapterLevelItemId: Scalars['String']['input'];
  conditions: Array<AddSingleQuestionQConfigStructureConditionInput>;
  location: AddSingleQuestionQConfigStructureLocationInput;
  qConfigId: Scalars['String']['input'];
  scorePerQuestion: Scalars['Int']['input'];
};

export type AddSingleQuestionQConfigStructureLocationInput = {
  locationType: AddQuestionQConfigStructureLocationType;
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddSingleQuestionQConfigStructureOutput = {
  __typename?: 'AddSingleQuestionQConfigStructureOutput';
  qConfig: QConfig;
};

export type AddUsersContentVisibilityInput = {
  contentId: Scalars['String']['input'];
  contentType: ContentType;
  parentContentId?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['String']['input']>;
};

export type AppPermission = {
  __typename?: 'AppPermission';
  action: Scalars['String']['output'];
  category: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AppRole = {
  __typename?: 'AppRole';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type AppRoleIdsInput = {
  appRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppRoleSearchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AppRoleSearchResult = {
  __typename?: 'AppRoleSearchResult';
  roles: Array<AppRole>;
  total: Scalars['Int']['output'];
};

export type AssignUserAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type AssignUserAppRoleMutationResponse = {
  __typename?: 'AssignUserAppRoleMutationResponse';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user: Maybe<Array<UserAppRoleView>>;
};

export type AssignUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserAppRolesMutationResponse = {
  __typename?: 'AssignUserAppRolesMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum AuditActionType {
  Add = 'ADD',
  Approve = 'APPROVE',
  AutoSync = 'AUTO_SYNC',
  ChangeStatus = 'CHANGE_STATUS',
  Create = 'CREATE',
  Delete = 'DELETE',
  Disable = 'DISABLE',
  Download = 'DOWNLOAD',
  Export = 'EXPORT',
  Grant = 'GRANT',
  Import = 'IMPORT',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  Reject = 'REJECT',
  Remove = 'REMOVE',
  Revoke = 'REVOKE',
  SendResultToWr = 'SEND_RESULT_TO_WR',
  Submit = 'SUBMIT',
  Update = 'UPDATE',
  Upload = 'UPLOAD',
  View = 'VIEW'
}

export enum AuditLogExecutionResult {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum AuditType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type ChangeItemSetQuestionInput = {
  qSetQuestionId: Scalars['String']['input'];
  questionGroupId: Scalars['String']['input'];
};

export type ChangeItemSetQuestionOutput = {
  __typename?: 'ChangeItemSetQuestionOutput';
  qSetQuestions: Array<QSetQuestion>;
};

export type ChangeSingleQuestionInput = {
  qSetQuestionId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type ChangeSingleQuestionOutput = {
  __typename?: 'ChangeSingleQuestionOutput';
  qSetQuestion: QSetQuestion;
};

export type ClearSessionOutputObjectType = {
  __typename?: 'ClearSessionOutputObjectType';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CommentEntityType {
  ExaminationCourse = 'EXAMINATION_COURSE',
  Other = 'OTHER',
  Qconfig = 'QCONFIG',
  Qset = 'QSET',
  Question = 'QUESTION'
}

export type ConditionTag = {
  __typename?: 'ConditionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ConditionTagObjectType = {
  __typename?: 'ConditionTagObjectType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ContentType {
  QbankStructure = 'QBANK_STRUCTURE',
  QbankStructureLevelChapter = 'QBANK_STRUCTURE_LEVEL_CHAPTER',
  QbankStructureLevelCourse = 'QBANK_STRUCTURE_LEVEL_COURSE',
  QbankStructureLevelGroup = 'QBANK_STRUCTURE_LEVEL_GROUP',
  QbankStructureLevelPart = 'QBANK_STRUCTURE_LEVEL_PART',
  QbankStructureLevelSubject = 'QBANK_STRUCTURE_LEVEL_SUBJECT',
  QbankStructureLevelSubTopic = 'QBANK_STRUCTURE_LEVEL_SUB_TOPIC',
  QbankStructureLevelTopic = 'QBANK_STRUCTURE_LEVEL_TOPIC'
}

export type ContentTypeScopeContentVisibilityResult = {
  __typename?: 'ContentTypeScopeContentVisibilityResult';
  contentIds: Array<Scalars['String']['output']>;
  contentType: ContentType;
};

export type ContentVisibility = {
  __typename?: 'ContentVisibility';
  contentId: Scalars['String']['output'];
  contentType: ContentType;
  id: Scalars['String']['output'];
  parentContentId: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type CreateAppRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAppRoleMutationResponse = {
  __typename?: 'CreateAppRoleMutationResponse';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  newAppRole: AppRole;
  success: Scalars['Boolean']['output'];
};

export type CreateExamCourseCommentInput = {
  content: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  taskId: Scalars['String']['input'];
};

export type CreateExamCourseCommentOutput = {
  __typename?: 'CreateExamCourseCommentOutput';
  comment: ExamCourseCommentOutput;
};

export type CreateExamCourseInput = {
  code: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  language: ExamCourseLanguage;
  name: Scalars['String']['input'];
  type: ExamCourseType;
};

export type CreateExamCourseOutput = {
  __typename?: 'CreateExamCourseOutput';
  examCourse: ExamCourse;
};

export type CreateInDevelopmentQuestionInput = {
  data: InDevelopmentQuestionInputData;
  qBankStructureLevelItemId: Scalars['String']['input'];
  refQBankStructureId: Scalars['String']['input'];
};

export type CreateItemSetInput = {
  name: Scalars['String']['input'];
  paragraph: Scalars['String']['input'];
  qBankStructureLevelItemId: Scalars['String']['input'];
  refQBankStructureId: Scalars['String']['input'];
  taskDetails?: InputMaybe<TaskDetailsForItemSetCreationInput>;
};

export type CreateLearningObjectiveStatementsInput = {
  chapterLevelItemId: Scalars['String']['input'];
  names: Array<Scalars['String']['input']>;
  qBankStructureId: Scalars['String']['input'];
};

export type CreateOrUpdateQuestionCommentInput = {
  content: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: CommentEntityType;
  taskId: Scalars['String']['input'];
};

export type CreateOrUpdateQuestionVerdictInput = {
  entityId: Scalars['String']['input'];
  entityType: VerdictEntityType;
  taskId: Scalars['String']['input'];
  verdict: Verdict;
};

export type CreateQBankStructureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  name: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  type: QBankStructureType;
};

export type CreateQConfigGeneratorConditionsInput = {
  qBankStructureLevelItems: Array<CreateQConfigGeneratorConditionsQBankStructureLevelItemInput>;
  questionTypes: Array<CreateQConfigGeneratorConditionsQuestionTypeInput>;
  tags: Array<CreateQConfigGeneratorConditionsTagInput>;
};

export type CreateQConfigGeneratorConditionsQBankStructureLevelItemInput = {
  needTotal: Scalars['Int']['input'];
  qBankStructureLevelItemId: Scalars['String']['input'];
};

export type CreateQConfigGeneratorConditionsQuestionTypeInput = {
  needTotal: Scalars['Int']['input'];
  type: QConfigQuestionType;
};

export type CreateQConfigGeneratorConditionsTagInput = {
  needTotal: Scalars['Int']['input'];
  tagId: Scalars['String']['input'];
};

export type CreateQConfigGeneratorInput = {
  conditions: CreateQConfigGeneratorConditionsInput;
  examCourseId: Scalars['String']['input'];
  generatorGroupLevel?: InputMaybe<QConfigGeneratorGroupLevel>;
  name: Scalars['String']['input'];
  needTotal: Scalars['Int']['input'];
  totalQuestions: Scalars['Int']['input'];
};

export type CreateQConfigGeneratorOutput = {
  __typename?: 'CreateQConfigGeneratorOutput';
  qConfigGenerator: QConfigGenerator;
};

export type CreateQConfigInput = {
  examCourseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  totalQuestions: Scalars['Float']['input'];
};

export type CreateQConfigOutput = {
  __typename?: 'CreateQConfigOutput';
  qConfig: QConfig;
};

export type CreateQSetsByGeneratorExecutionInput = {
  id: Scalars['String']['input'];
  resultIds: Array<Scalars['String']['input']>;
};

export type CreateQSetsByGeneratorExecutionOutput = {
  __typename?: 'CreateQSetsByGeneratorExecutionOutput';
  qSets: Array<QSet>;
};

export type CreateQuestionCreationTaskInput = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requirement: CreateQuestionCreationTaskRequirementInput;
};

export type CreateQuestionCreationTaskOutput = {
  __typename?: 'CreateQuestionCreationTaskOutput';
  task: Task;
};

export type CreateQuestionCreationTaskRequirementInput = {
  details: Scalars['String']['input'];
  itemSetCondition?: InputMaybe<Array<ItemSetCreationRequirementInput>>;
  qBankStructureId: Scalars['String']['input'];
  requiredQuestionCount: Scalars['Int']['input'];
};

export type CreateQuestionInput = {
  data: QuestionInputData;
  qBankStructureLevelItemId: Scalars['String']['input'];
  refQBankStructureId: Scalars['String']['input'];
};

export type CreateQuestionReviewSubtaskByCreateTask = {
  assigneeId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum CreateQuestionReviewTaskAndSubtasksErrorCode {
  ItemSetMismatch = 'ITEM_SET_MISMATCH',
  QuestionsNotFound = 'QUESTIONS_NOT_FOUND',
  QuestionsNotPreDraft = 'QUESTIONS_NOT_PRE_DRAFT'
}

export type CreateQuestionReviewTaskInput = {
  assigneeId: Scalars['String']['input'];
  assignerId: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['StringOrStringArray']['input']>;
  entityType?: InputMaybe<EntityType>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  subtasks?: InputMaybe<Array<CreateQuestionReviewSubtaskByCreateTask>>;
  workflowCode: WorkflowCode;
};

export type CreateQuestionReviewTaskOutput = {
  __typename?: 'CreateQuestionReviewTaskOutput';
  code: Maybe<CreateQuestionReviewTaskAndSubtasksErrorCode>;
  itemSetMismatches: Array<CreateTaskAndSubtasksItemSetMismatch>;
  message: Scalars['String']['output'];
  subtasks: Array<Task>;
  success: Scalars['Boolean']['output'];
  task: Maybe<Task>;
};

export type CreateSubtaskByCreateTask = {
  assigneeId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTaskAndSubtasksInput = {
  assigneeId: Scalars['String']['input'];
  assignerId: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['StringOrStringArray']['input']>;
  entityType?: InputMaybe<EntityType>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  subtasks?: InputMaybe<Array<CreateSubtaskByCreateTask>>;
  workflowCode: WorkflowCode;
};

export type CreateTaskAndSubtasksItemSetMismatch = {
  __typename?: 'CreateTaskAndSubtasksItemSetMismatch';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  refCode: Scalars['String']['output'];
};

export type CreateTaskAndSubtasksOutput = {
  __typename?: 'CreateTaskAndSubtasksOutput';
  subtasks: Array<Task>;
  task: Task;
};

export type CreateTaskCommentInput = {
  content: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type CreateTaskCommentOutput = {
  __typename?: 'CreateTaskCommentOutput';
  comment: TaskComment;
};

export type DeleteAppRoleInput = {
  appRoleId: Scalars['String']['input'];
};

export type DeleteAppRoleMutationResponse = {
  __typename?: 'DeleteAppRoleMutationResponse';
  appRole: AppRole;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteItemSetSubQuestionInput = {
  itemSetId: Scalars['String']['input'];
  subQuestionId: Scalars['String']['input'];
};

export type DeleteLearningObjectiveStatementInput = {
  chapterLevelItemId: Scalars['String']['input'];
  learningObjectiveStatementId: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
};

export type DeleteQConfigInput = {
  qConfigId: Scalars['String']['input'];
};

export type DeleteQConfigOutput = {
  __typename?: 'DeleteQConfigOutput';
  qConfig: QConfig;
};

export type DeleteQConfigStructureInput = {
  qConfigId: Scalars['String']['input'];
  qConfigStructureId: Scalars['String']['input'];
};

export type DeleteQConfigStructureOutput = {
  __typename?: 'DeleteQConfigStructureOutput';
  qConfig: QConfig;
};

export type DeleteQSetByIdInput = {
  id: Scalars['String']['input'];
};

export type DeleteQSetByIdOutput = {
  __typename?: 'DeleteQSetByIdOutput';
  message: Scalars['String']['output'];
};

export type DeleteSubtaskInput = {
  subtaskId: Scalars['String']['input'];
};

export type DeleteSubtaskOutput = {
  __typename?: 'DeleteSubtaskOutput';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DisableLearningObjectiveStatementInput = {
  chapterLevelItemId: Scalars['String']['input'];
  learningObjectiveStatementId: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
};

export type DisableQConfigInput = {
  qConfigId: Scalars['String']['input'];
};

export type DisableQConfigOutput = {
  __typename?: 'DisableQConfigOutput';
  qConfig: QConfig;
};

export type DisableQSetsInput = {
  qSetIds: Array<Scalars['String']['input']>;
};

export type DisableQSetsOutput = {
  __typename?: 'DisableQSetsOutput';
  qSets: Array<QSet>;
};

export type DisabledLearningObjectiveStatementObjectType = {
  __typename?: 'DisabledLearningObjectiveStatementObjectType';
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type DuplicateQBankStructureInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DuplicateQConfigInput = {
  name: Scalars['String']['input'];
  qConfigId: Scalars['String']['input'];
};

export type DuplicateQConfigOutput = {
  __typename?: 'DuplicateQConfigOutput';
  qConfig: QConfig;
};

export type DuplicateQSetInput = {
  qSetId: Scalars['String']['input'];
};

export type DuplicateQSetOutput = {
  __typename?: 'DuplicateQSetOutput';
  qSet: QSet;
};

export type DuplicateQuestionInput = {
  qBankStructureLevelItemId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

/** The EntityType of entityId. */
export enum EntityType {
  ExaminationCourse = 'EXAMINATION_COURSE',
  ExamLocationRoomRequestInfo = 'EXAM_LOCATION_ROOM_REQUEST_INFO',
  Other = 'OTHER',
  ProctorRequest = 'PROCTOR_REQUEST',
  Qconfig = 'QCONFIG',
  Qcontent = 'QCONTENT',
  Qset = 'QSET',
  Question = 'QUESTION',
  QuestionGroup = 'QUESTION_GROUP'
}

export type ExamCourse = {
  __typename?: 'ExamCourse';
  code: Scalars['String']['output'];
  examId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  language: ExamCourseLanguage;
  name: Scalars['String']['output'];
  tagEntities: Maybe<Array<TagEntity>>;
  totalQConfig: Scalars['Int']['output'];
  totalQSet: Scalars['Int']['output'];
  type: ExamCourseType;
};

export type ExamCourseCommentOutput = {
  __typename?: 'ExamCourseCommentOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: RawUser;
  userId: Scalars['String']['output'];
};

export enum ExamCourseLanguage {
  En = 'EN',
  Th = 'TH'
}

export type ExamCourseTask = {
  __typename?: 'ExamCourseTask';
  code: Scalars['String']['output'];
  examId: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  language: ExamCourseLanguage;
  name: Scalars['String']['output'];
  totalQConfig: Scalars['Float']['output'];
  totalQSet: Scalars['Float']['output'];
  type: ExamCourseType;
};

export enum ExamCourseType {
  Main = 'MAIN',
  Mock = 'MOCK'
}

export type ExamCourseVerdictOutput = {
  __typename?: 'ExamCourseVerdictOutput';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: RawUser;
  userId: Scalars['String']['output'];
  verdict: Verdict;
};

export enum ExamUsageStatus {
  Assigned = 'ASSIGNED',
  Inactive = 'INACTIVE',
  InUse = 'IN_USE',
  Ready = 'READY'
}

/** The type of the entity being reviewed. */
export enum ExaminationEntityType {
  ExaminationCourse = 'EXAMINATION_COURSE',
  ExamLocationRoomRequestInfo = 'EXAM_LOCATION_ROOM_REQUEST_INFO',
  Other = 'OTHER',
  ProctorRequest = 'PROCTOR_REQUEST',
  Qconfig = 'QCONFIG',
  Qcontent = 'QCONTENT',
  Qset = 'QSET',
  Question = 'QUESTION',
  QuestionGroup = 'QUESTION_GROUP'
}

export type ExecuteQSetGeneratorInput = {
  duplicationRate: Scalars['Int']['input'];
  needTotal: Scalars['Int']['input'];
  qConfigId: Scalars['String']['input'];
};

export type ExecuteQSetGeneratorOutput = {
  __typename?: 'ExecuteQSetGeneratorOutput';
  qSetGeneratorExecution: QSetGeneratorExecution;
};

export enum ExportItemSetFormat {
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type ExportItemSetInput = {
  format: ExportItemSetFormat;
  includeSolution: Scalars['Boolean']['input'];
  questionGroupId: Scalars['String']['input'];
};

export enum ExportQSetFormat {
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type ExportQSetInput = {
  format: ExportQSetFormat;
  includeSolution: Scalars['Boolean']['input'];
  qSetId: Scalars['String']['input'];
};

export type ExportQSetOutput = {
  __typename?: 'ExportQSetOutput';
  message: Scalars['String']['output'];
};

export type ExportQuestionResult = {
  __typename?: 'ExportQuestionResult';
  message: Scalars['String']['output'];
};

export type ExportSearchResultsInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  questionIds: Array<Scalars['String']['input']>;
  sourceFeature: ExportSearchResultsSourceFeature;
};

export enum ExportSearchResultsSourceFeature {
  SearchByKeyword = 'SEARCH_BY_KEYWORD',
  SearchByQid = 'SEARCH_BY_QID'
}

export enum ExportSingleQuestionFormat {
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type ExportSingleQuestionInput = {
  format: ExportSingleQuestionFormat;
  includeSolution: Scalars['Boolean']['input'];
  questionId: Scalars['String']['input'];
};

export type ExportTaskQSetInput = {
  format: ExportQSetFormat;
  includeSolution: Scalars['Boolean']['input'];
  qSetId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type FilterConditionInput = {
  /** Field to filter by */
  field: Scalars['String']['input'];
  operator: FilterOperator;
  /** Value to filter by */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum FilterOperator {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  Like = 'LIKE',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export enum FilterOperatorEnum {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  Like = 'LIKE',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export type GenerateTwoFactorSecretOutputObjectType = {
  __typename?: 'GenerateTwoFactorSecretOutputObjectType';
  email: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export enum GenericResponseStatus {
  Success = 'SUCCESS'
}

export type GetAppRoleOutputObjectType = {
  __typename?: 'GetAppRoleOutputObjectType';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type GetDisabledLearningObjectiveStatementsByQConfigIdInput = {
  qConfigId: Scalars['String']['input'];
};

export type GetDisabledLearningObjectiveStatementsByQConfigIdOutput = {
  __typename?: 'GetDisabledLearningObjectiveStatementsByQConfigIdOutput';
  disabledLearningObjectiveStatements: Array<DisabledLearningObjectiveStatementObjectType>;
};

export type GetDownloadSignedUrlForExamCourseCommentInput = {
  fileNames: Array<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};

export type GetDownloadSignedUrlForExamCourseCommentOutput = {
  __typename?: 'GetDownloadSignedUrlForExamCourseCommentOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForQuestionGroupsInput = {
  questionGroupFileInputs: Array<QuestionGroupFileInput>;
};

export type GetDownloadSignedUrlForQuestionGroupsResult = {
  __typename?: 'GetDownloadSignedUrlForQuestionGroupsResult';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForQuestionsByQSetIdInput = {
  qSetId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type GetDownloadSignedUrlForQuestionsByQSetIdOutput = {
  __typename?: 'GetDownloadSignedUrlForQuestionsByQSetIdOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForQuestionsInput = {
  questionFileInputs: Array<QuestionFileInput>;
};

export type GetDownloadSignedUrlForQuestionsResult = {
  __typename?: 'GetDownloadSignedUrlForQuestionsResult';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForTaskInput = {
  fileNames: Array<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};

export type GetDownloadSignedUrlForTaskOutput = {
  __typename?: 'GetDownloadSignedUrlForTaskOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlQuestionInput = {
  fileNames: Array<Scalars['String']['input']>;
  questionGroupId?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlsResult = {
  __typename?: 'GetDownloadSignedUrlsResult';
  signedUrls: Scalars['JSON']['output'];
};

export type GetExamCourseByIdInput = {
  examCourseId: Scalars['String']['input'];
};

export type GetExamCourseByIdOutput = {
  __typename?: 'GetExamCourseByIdOutput';
  examCourse: ExamCourse;
};

export type GetExamCourseCommentsInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  taskId: Scalars['String']['input'];
};

export type GetExamCourseCommentsOutput = {
  __typename?: 'GetExamCourseCommentsOutput';
  comments: Array<ExamCourseCommentOutput>;
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  taskId: Scalars['String']['output'];
};

export type GetExamCourseGroupByIdInput = {
  examCourseGroupId: Scalars['String']['input'];
};

export type GetExamCourseGroupByIdOutput = {
  __typename?: 'GetExamCourseGroupByIdOutput';
  tag: Tag;
};

export type GetExamCourseVerdictInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  taskId: Scalars['String']['input'];
};

export type GetExamCourseVerdictOutput = {
  __typename?: 'GetExamCourseVerdictOutput';
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  taskId: Scalars['String']['output'];
  verdict: ExamCourseVerdictOutput;
};

export type GetItemSetQuestionPropertiesByStatusAndLocationInputType = {
  locationType: ItemSetQuestionPropertiesLocationType;
  qBankStructureId: Scalars['String']['input'];
  status: ItemSetQuestionPropertiesStatus;
};

export type GetItemSetQuestionPropertiesCountByLocationInputType = {
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  size: Scalars['Int']['input'];
  type: ItemSetQuestionPropertiesLocationType;
};

export type GetLearningObjectiveStatementByIdInput = {
  id: Scalars['String']['input'];
};

export type GetMyTasksInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type GetMyTasksOutput = {
  __typename?: 'GetMyTasksOutput';
  tasks: Array<Task>;
  total: Scalars['Float']['output'];
};

export type GetQBankStructureLevelItemsByQBankStructureIdOptions = {
  categories?: InputMaybe<Array<QBankStructureLevelCategory>>;
};

export type GetQConfigByIdInput = {
  qConfigId: Scalars['String']['input'];
};

export type GetQConfigByIdOutput = {
  __typename?: 'GetQConfigByIdOutput';
  qConfig: QConfig;
};

export type GetQConfigGeneratorByIdInput = {
  id: Scalars['String']['input'];
};

export type GetQConfigGeneratorByIdOutput = {
  __typename?: 'GetQConfigGeneratorByIdOutput';
  qConfigGenerator: QConfigGenerator;
};

export type GetQSetByIdInput = {
  id: Scalars['String']['input'];
};

export type GetQSetByIdOutput = {
  __typename?: 'GetQSetByIdOutput';
  qSet: QSet;
};

export type GetQSetByTaskIdInput = {
  taskId: Scalars['String']['input'];
};

export type GetQSetByTaskIdOutput = {
  __typename?: 'GetQSetByTaskIdOutput';
  qSet: QSet;
};

export type GetQSetGeneratorExecutionByIdInput = {
  id: Scalars['String']['input'];
};

export type GetQSetGeneratorExecutionByIdOutput = {
  __typename?: 'GetQSetGeneratorExecutionByIdOutput';
  qSetGeneratorExecution: QSetGeneratorExecution;
};

export type GetQSetQuestionsByQuestionIdsOutput = {
  __typename?: 'GetQSetQuestionsByQuestionIdsOutput';
  qSetQuestions: Array<QSetQuestion>;
};

export type GetQSetQuestionsByTaskIdInput = {
  taskId: Scalars['String']['input'];
};

export type GetQSetQuestionsByTaskIdOutput = {
  __typename?: 'GetQSetQuestionsByTaskIdOutput';
  qSetQuestions: Array<QSetQuestion>;
};

export type GetQSetSimilaritiesInput = {
  qSetsA: Array<QSetComparisonInput>;
  qSetsB?: InputMaybe<Array<QSetComparisonInput>>;
};

export type GetQSetSimilaritiesOutput = {
  __typename?: 'GetQSetSimilaritiesOutput';
  id: Scalars['String']['output'];
  qSetSimilarityResults: Array<QSetSimilarityResultOutput>;
};

export type GetQSetSimilarityByIdInput = {
  id: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
};

export type GetQSetSimilarityByIdOutput = {
  __typename?: 'GetQSetSimilarityByIdOutput';
  id: Scalars['String']['output'];
  qSetSimilarityResult: QSetSimilarityResultWithQuestionsOutput;
};

export type GetQSetTaskReviewSummaryInput = {
  mainTaskId: Scalars['String']['input'];
  qSetId: Scalars['String']['input'];
  verdicts?: InputMaybe<Array<Verdict>>;
};

export type GetQSetTaskReviewSummaryOutput = {
  __typename?: 'GetQSetTaskReviewSummaryOutput';
  results: Array<QSetTaskReviewSummaryOutput>;
  subTaskIds: Array<Scalars['String']['output']>;
};

export type GetQsetQuestionsByQuestionIdsInput = {
  qSetId: Scalars['String']['input'];
  questionIds: Array<Scalars['String']['input']>;
};

export type GetQuestionCommentsByEntityAndTaskIdInput = {
  entityId: Scalars['String']['input'];
  entityType: CommentEntityType;
  taskId: Scalars['String']['input'];
};

export type GetQuestionGroupsByQBankStructureLevelItemIdInput = {
  qBankStructureLevelItemId: Scalars['String']['input'];
  type?: InputMaybe<QuestionGroupType>;
};

export type GetQuestionUsageByIdOutput = {
  __typename?: 'GetQuestionUsageByIdOutput';
  examCourseCode: Scalars['String']['output'];
  examCourseName: Scalars['String']['output'];
  qConfigRefCode: Scalars['Int']['output'];
  qSetCode: Scalars['String']['output'];
  qSetQuestionId: Scalars['String']['output'];
  qSetQuestionOrder: Scalars['Int']['output'];
  qSetStatus: Scalars['String']['output'];
};

export type GetQuestionVerdictsByEntityAndTaskIdInput = {
  entityId: Scalars['String']['input'];
  entityType: VerdictEntityType;
  taskId: Scalars['String']['input'];
};

export type GetSingleQuestionPropertiesByStatusAndLocationInputType = {
  locationType: SingleQuestionPropertiesLocationType;
  qBankStructureId: Scalars['String']['input'];
  status: SingleQuestionPropertiesStatus;
};

export type GetSingleQuestionPropertiesCountByLocationInput = {
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type: SingleQuestionPropertiesLocationType;
};

export type GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationInputType = {
  qBankStructureLevelItemIds: Array<Scalars['String']['input']>;
  status: QuestionStatus;
};

export type GetStepTransitionsByTaskIdInput = {
  taskId: Scalars['String']['input'];
};

export type GetStepTransitionsByTaskIdOutput = {
  __typename?: 'GetStepTransitionsByTaskIdOutput';
  steps: Array<StepTransition>;
};

export type GetTagsByCategoryInput = {
  category: QuestionTagCategory;
};

export type GetTaskByIdInput = {
  taskId: Scalars['String']['input'];
};

export type GetTaskByIdOutput = {
  __typename?: 'GetTaskByIdOutput';
  task: Task;
};

export type GetTaskCommentsInput = {
  taskId: Scalars['String']['input'];
};

export type GetTaskCommentsOutput = {
  __typename?: 'GetTaskCommentsOutput';
  comments: Array<TaskComment>;
  taskId: Scalars['String']['output'];
};

export type GetTaskQuestionVerdictsInput = {
  taskId: Scalars['String']['input'];
};

export type GetTaskReviewResultsInput = {
  taskId: Scalars['String']['input'];
  verdicts?: InputMaybe<Array<Verdict>>;
};

export type GetTaskReviewResultsOutput = {
  __typename?: 'GetTaskReviewResultsOutput';
  results: Array<QSetReviewTaskResultOutput>;
  taskId: Scalars['String']['output'];
};

export type GetTaskVerdictInput = {
  taskId: Scalars['String']['input'];
};

export type GetTaskVerdictOutput = {
  __typename?: 'GetTaskVerdictOutput';
  id: Scalars['String']['output'];
  verdict: Maybe<Verdict>;
};

export type GetTasksByEntityInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
};

export type GetTasksByEntityWithParentOutput = {
  __typename?: 'GetTasksByEntityWithParentOutput';
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  tasks: Array<TaskWithSubtasks>;
};

export type GetUploadSignedUrlForExamCourseCommentInput = {
  contentType: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForExamCourseCommentOutput = {
  __typename?: 'GetUploadSignedUrlForExamCourseCommentOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlForQuestionCreationTaskInput = {
  contentType: Scalars['String']['input'];
};

export type GetUploadSignedUrlForQuestionCreationTaskOutput = {
  __typename?: 'GetUploadSignedUrlForQuestionCreationTaskOutput';
  contentType: QuestionCreationTaskContentType;
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlForTaskInput = {
  contentType: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForTaskOutput = {
  __typename?: 'GetUploadSignedUrlForTaskOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlImportQuestionSpreadsheetInput = {
  contentType: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
};

export type GetUploadSignedUrlQuestionInput = {
  contentType: Scalars['String']['input'];
  questionGroupId?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
};

export type GetUploadSignedUrlResult = {
  __typename?: 'GetUploadSignedUrlResult';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUserByIdOutputObjectType = {
  __typename?: 'GetUserByIdOutputObjectType';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type GroupOrderInput = {
  groupOrder: Scalars['Float']['input'];
  questionId: Scalars['String']['input'];
};

export type ImportQuestionSpreadsheetInput = {
  fileName: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
  type: QuestionImportType;
};

export type ImportQuestionSpreadsheetResult = {
  __typename?: 'ImportQuestionSpreadsheetResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type InDevelopmentQuestionInputData = {
  bIndexValue?: InputMaybe<Scalars['Float']['input']>;
  calculated: Scalars['Boolean']['input'];
  choices: Array<QuestionChoiceInput>;
  cognitiveDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  correctAnswer: QuestionCorrectAnswerInput;
  details: Scalars['String']['input'];
  group: QuestionInputGroup;
  learningObjectiveStatement: Scalars['String']['input'];
  pValue: Scalars['Float']['input'];
  reference: Scalars['String']['input'];
  solution: Scalars['String']['input'];
};

export type ItemSetCondition = {
  __typename?: 'ItemSetCondition';
  needTotal: Scalars['Float']['output'];
  size: Scalars['Float']['output'];
};

export type ItemSetCreation = {
  __typename?: 'ItemSetCreation';
  questionCreationCount: Scalars['Float']['output'];
  questionGroupId: Scalars['String']['output'];
  size: Scalars['Float']['output'];
};

export type ItemSetCreationRequirementInput = {
  needTotal: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type ItemSetQuestionProperties = {
  __typename?: 'ItemSetQuestionProperties';
  tagGroups: Array<TagGroup>;
  totalQuestions: Scalars['Int']['output'];
};

export type ItemSetQuestionPropertiesByLocation = {
  __typename?: 'ItemSetQuestionPropertiesByLocation';
  locationId: Scalars['String']['output'];
  locationType: ItemSetQuestionPropertiesLocationType;
  questionProperties: Array<ItemSetQuestionProperties>;
  size: Scalars['Int']['output'];
};

export enum ItemSetQuestionPropertiesLocationType {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export enum ItemSetQuestionPropertiesStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type JsonContainsFilterInput = {
  field: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type LearningObjectiveStatement = {
  __typename?: 'LearningObjectiveStatement';
  activeQuestionCount: LearningObjectiveStatementActiveQuestionCountDto;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  qBankStructureId: Scalars['String']['output'];
  qBankStructureLevelItem: Maybe<QBankStructureLevelItem>;
  qBankStructureLevelItemId: Maybe<Scalars['String']['output']>;
  status: LearningObjectiveStatementStatus;
  tag: Tag;
  tagId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LearningObjectiveStatementActiveQuestionCountDto = {
  __typename?: 'LearningObjectiveStatementActiveQuestionCountDTO';
  itemSet: Scalars['Float']['output'];
  single: Scalars['Float']['output'];
};

export enum LearningObjectiveStatementStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type LearningObjectiveStatementsResult = {
  __typename?: 'LearningObjectiveStatementsResult';
  learningObjectiveStatements: Array<LearningObjectiveStatement>;
  total: Scalars['Float']['output'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  code: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LoginTwoFactorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LoginTwoFactorResponse = {
  __typename?: 'LoginTwoFactorResponse';
  code: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogoutOutputObjectType = {
  __typename?: 'LogoutOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assignUserAppRoles: AssignUserAppRolesMutationResponse;
  cvAddUsersContentVisibility: UsersContentVisibilityResult;
  cvRemoveUsersContentVisibility: RemoveUsersContentVisibilityResult;
  cvUpdateUserQBankStructureLevelItemContentVisibility: UpdateUsersContentVisibilityResult;
  excAddItemSetQuestionQConfigStructure: AddItemSetQuestionQConfigStructureOutput;
  excAddQConfigStructures: AddQConfigStructuresOutput;
  excAddSingleQuestionQConfigStructure: AddSingleQuestionQConfigStructureOutput;
  excChangeItemSetQuestion: ChangeItemSetQuestionOutput;
  excChangeSingleQuestion: ChangeSingleQuestionOutput;
  excCreateExamCourse: CreateExamCourseOutput;
  excCreateExamCourseComment: CreateExamCourseCommentOutput;
  excCreateQConfig: CreateQConfigOutput;
  excCreateQConfigGenerator: CreateQConfigGeneratorOutput;
  excCreateQSetsByGeneratorExecution: CreateQSetsByGeneratorExecutionOutput;
  excDeleteQConfig: DeleteQConfigOutput;
  excDeleteQConfigStructure: DeleteQConfigStructureOutput;
  excDeleteQSetById: DeleteQSetByIdOutput;
  excDisableQConfig: DisableQConfigOutput;
  excDisableQSets: DisableQSetsOutput;
  excDuplicateQConfig: DuplicateQConfigOutput;
  excDuplicateQSet: DuplicateQSetOutput;
  excExecuteQSetGenerator: ExecuteQSetGeneratorOutput;
  excPublishQConfig: PublishQConfigOutput;
  excPublishQSets: GenericResponse;
  excUpdateExamUsageOfQSets: UpdateExamUsageOfQSetsOutput;
  excUpdateItemSetQuestionQConfigStructure: UpdateItemSetQuestionQConfigStructureOutput;
  excUpdateOrCreateExamCourseVerdict: UpdateOrCreateExamCourseVerdictOutput;
  excUpdateQConfigAsDraft: UpdateQConfigAsDraftOutput;
  excUpdateQConfigStructureNames: UpdateQConfigStructureNamesOutput;
  excUpdateQconfigSettingsAsDraft: UpdateQConfigSettingsAsDraftOutput;
  excUpdateSingleQuestionQConfigStructure: UpdateSingleQuestionQConfigStructureOutput;
  qbsArchiveQBankStructure: QBankStructure;
  qbsCreateLearningObjectiveStatements: Array<LearningObjectiveStatement>;
  qbsCreateQBankStructure: QBankStructure;
  qbsDeleteLearningObjectiveStatement: GenericResponse;
  qbsDisableLearningObjectiveStatement: LearningObjectiveStatement;
  qbsDuplicateQBankStructure: QBankStructure;
  qbsPublishQBankStructure: QBankStructure;
  qbsSaveAsDraft: GenericResponse;
  qbsSaveAsUnpublished: GenericResponse;
  qbsUnpublishQBankStructure: QBankStructure;
  qbsUpdateLearningObjectiveStatement: LearningObjectiveStatement;
  qbsUpdateQBankStructureAsArchived: QBankStructure;
  qbsUpdateQBankStructureAsDraft: QBankStructure;
  qbsUpdateQBankStructureAsPublished: QBankStructure;
  qbsUpdateQBankStructureAsUnpublished: QBankStructure;
  qbsUpdateQBankStructureLevelsByQBankStructureId: Array<QBankStructureLevel>;
  qbsUpdateUsersQBankStructureLevelItemContentVisibility: UpdateUsersContentVisibilityResult;
  qctCreateInDevelopmentQuestion: Question;
  qctCreateItemSet: QuestionGroup;
  qctCreateItemSetWorkflow: QuestionGroup;
  qctCreateOrUpdateQuestionComment: QuestionComment;
  qctCreateOrUpdateQuestionVerdict: QuestionVerdict;
  qctCreateQuestion: Question;
  qctDeleteItemSetSubQuestion: QuestionGroup;
  qctDeleteItemSetSubQuestionWorkflow: QuestionGroup;
  qctDisableItemSet: QuestionGroup;
  qctDisableQuestion: Question;
  qctDuplicateQuestion: Question;
  qctExportItemSet: ExportQuestionResult;
  qctExportSearchResults: ExportQuestionResult;
  qctExportSingleQuestion: ExportQuestionResult;
  qctImportQuestionSpreadsheet: ImportQuestionSpreadsheetResult;
  qctPublishItemSet: QuestionGroup;
  qctPublishQuestion: Question;
  qctSaveItemSetAsDraft: QuestionGroup;
  qctSaveItemSetAsDraftWorkflow: QuestionGroup;
  qctSaveItemSetAsUnpublish: QuestionGroup;
  qctSaveQuestionAsDraft: Question;
  qctSaveQuestionAsInDevelopment: Question;
  qctSaveQuestionAsUnpublish: Question;
  qctUnpublishItemSet: QuestionGroup;
  qctUnpublishQuestion: Question;
  suAcceptResetPassword: AcceptResetPasswordOutputObjectType;
  suAssignUserAppRole: AssignUserAppRoleMutationResponse;
  suClearSession: ClearSessionOutputObjectType;
  suCreateAppRole: CreateAppRoleMutationResponse;
  suDeleteAppRole: DeleteAppRoleMutationResponse;
  suGenerateTwoFactorSecret: GenerateTwoFactorSecretOutputObjectType;
  suLogin: LoginResponse;
  suLoginTwoFactor: LoginTwoFactorResponse;
  suLogout: LogoutOutputObjectType;
  suQuickCreateUser: QuickCreateUserObjectType;
  suResendResetPasswordEmail: ResendResetPasswordEmailOutputObjectType;
  suResendResetPasswordUserLocked: ResendResetPasswordUserLockedOutputObjectType;
  suResetPassword: ResetPasswordOutputObjectType;
  suResetUserTwoFactor: ResetUserTwoFactorOutputObjectType;
  suUnassignUserAppRoles: UnassignUserAppRolesMutationResponse;
  suUnlockUserTwoFactor: UnlockUserTwoFactorOutputObjectType;
  suUpdateAppRole: UpdateAppRoleMutationResponse;
  suUpdateAppRoleAppPermissions: UpdateAppRoleAppPermissionsMutationResponse;
  suUpdateUser: UpdateUserOutputObjectType;
  suUpdateUserStatus: UpdateUserStatusOutputObjectType;
  suVerifyUserTwoFactor: VerifyUserTwoFactorOutputObjectType;
  unassignUserAppRole: AssignUserAppRoleMutationResponse;
  updateUserAppRoleByNames: UpdateUserAppRoleByNameMutationResponse;
  updateUserAppRoles: UpdateUserAppRolesMutationResponse;
  wflCreateQuestionCreationTask: CreateQuestionCreationTaskOutput;
  wflCreateQuestionReviewTask: CreateQuestionReviewTaskOutput;
  wflCreateTaskAndSubtasks: CreateTaskAndSubtasksOutput;
  wflCreateTaskComment: CreateTaskCommentOutput;
  wflDeleteSubtask: DeleteSubtaskOutput;
  wflSubmitQSetReview: SubmitQSetReviewOutput;
  wflSubmitQuestionReview: SubmitQuestionReviewOutput;
  wflUpdateAndCreateSubtasks: UpdateAndCreateSubtasksOutput;
  wflUpdateDueDateTaskAndSubtasks: UpdateTaskOutputObjectType;
  wflUpdateQuestionCreationTask: UpdateQuestionCreationTaskOutputDto;
  wflUpdateSubtasks: UpdateSubtasksOutput;
  wflUpdateTask: UpdateTaskOutputObjectType;
  wflUpdateTaskAndSubtasksAndCreateSubtasks: UpdateTaskAndSubtasksAndCreateSubtasksOutput;
  wflUpdateTaskStatus: UpdateTaskStatusOutput;
};


export type MutationAssignUserAppRolesArgs = {
  data: AssignUserAppRolesInput;
};


export type MutationCvAddUsersContentVisibilityArgs = {
  input: AddUsersContentVisibilityInput;
};


export type MutationCvRemoveUsersContentVisibilityArgs = {
  input: RemoveUsersContentVisibilityInput;
};


export type MutationCvUpdateUserQBankStructureLevelItemContentVisibilityArgs = {
  input: UpdateUsersContentVisibilityInput;
};


export type MutationExcAddItemSetQuestionQConfigStructureArgs = {
  addItemSetQuestionQConfigStructureInput: AddItemSetQuestionQConfigStructureInput;
};


export type MutationExcAddQConfigStructuresArgs = {
  addQConfigStructuresInput: AddQConfigStructuresInput;
};


export type MutationExcAddSingleQuestionQConfigStructureArgs = {
  addSingleQuestionQConfigStructureInput: AddSingleQuestionQConfigStructureInput;
};


export type MutationExcChangeItemSetQuestionArgs = {
  changeItemSetQuestionInput: ChangeItemSetQuestionInput;
};


export type MutationExcChangeSingleQuestionArgs = {
  changeSingleQuestionInput: ChangeSingleQuestionInput;
};


export type MutationExcCreateExamCourseArgs = {
  createExamCourseInput: CreateExamCourseInput;
};


export type MutationExcCreateExamCourseCommentArgs = {
  CreateExamCourseCommentInput: CreateExamCourseCommentInput;
};


export type MutationExcCreateQConfigArgs = {
  createQConfigInput: CreateQConfigInput;
};


export type MutationExcCreateQConfigGeneratorArgs = {
  CreateQConfigGeneratorInput: CreateQConfigGeneratorInput;
};


export type MutationExcCreateQSetsByGeneratorExecutionArgs = {
  input: CreateQSetsByGeneratorExecutionInput;
};


export type MutationExcDeleteQConfigArgs = {
  deleteQConfigInput: DeleteQConfigInput;
};


export type MutationExcDeleteQConfigStructureArgs = {
  deleteQConfigStructureInput: DeleteQConfigStructureInput;
};


export type MutationExcDeleteQSetByIdArgs = {
  input: DeleteQSetByIdInput;
};


export type MutationExcDisableQConfigArgs = {
  disableQConfigInput: DisableQConfigInput;
};


export type MutationExcDisableQSetsArgs = {
  input: DisableQSetsInput;
};


export type MutationExcDuplicateQConfigArgs = {
  duplicateQConfigInput: DuplicateQConfigInput;
};


export type MutationExcDuplicateQSetArgs = {
  input: DuplicateQSetInput;
};


export type MutationExcExecuteQSetGeneratorArgs = {
  ExecuteQSetGeneratorInput: ExecuteQSetGeneratorInput;
};


export type MutationExcPublishQConfigArgs = {
  publishQConfigInput: PublishQConfigInput;
};


export type MutationExcPublishQSetsArgs = {
  input: PublishQSetsInput;
};


export type MutationExcUpdateExamUsageOfQSetsArgs = {
  input: UpdateExamUsageOfQSetsInput;
};


export type MutationExcUpdateItemSetQuestionQConfigStructureArgs = {
  updateItemSetQuestionQConfigStructureInput: UpdateItemSetQuestionQConfigStructureInput;
};


export type MutationExcUpdateOrCreateExamCourseVerdictArgs = {
  UpdateOrCreateExamCourseVerdictInput: UpdateOrCreateExamCourseVerdictInput;
};


export type MutationExcUpdateQConfigAsDraftArgs = {
  updateQConfigAsDraftInput: UpdateQConfigAsDraftInput;
};


export type MutationExcUpdateQConfigStructureNamesArgs = {
  updateQConfigStructureNamesInput: UpdateQConfigStructureNamesInput;
};


export type MutationExcUpdateQconfigSettingsAsDraftArgs = {
  updateQConfigSettingsAsDraftInput: UpdateQConfigSettingsAsDraftInput;
};


export type MutationExcUpdateSingleQuestionQConfigStructureArgs = {
  updateSingleQuestionQConfigStructureInput: UpdateSingleQuestionQConfigStructureInput;
};


export type MutationQbsArchiveQBankStructureArgs = {
  id: Scalars['String']['input'];
};


export type MutationQbsCreateLearningObjectiveStatementsArgs = {
  input: CreateLearningObjectiveStatementsInput;
};


export type MutationQbsCreateQBankStructureArgs = {
  input: CreateQBankStructureInput;
};


export type MutationQbsDeleteLearningObjectiveStatementArgs = {
  input: DeleteLearningObjectiveStatementInput;
};


export type MutationQbsDisableLearningObjectiveStatementArgs = {
  input: DisableLearningObjectiveStatementInput;
};


export type MutationQbsDuplicateQBankStructureArgs = {
  input: DuplicateQBankStructureInput;
};


export type MutationQbsPublishQBankStructureArgs = {
  id: Scalars['String']['input'];
};


export type MutationQbsSaveAsDraftArgs = {
  input: SaveAsInput;
};


export type MutationQbsSaveAsUnpublishedArgs = {
  input: SaveAsInput;
};


export type MutationQbsUnpublishQBankStructureArgs = {
  id: Scalars['String']['input'];
};


export type MutationQbsUpdateLearningObjectiveStatementArgs = {
  input: UpdateLearningObjectiveStatementInput;
};


export type MutationQbsUpdateQBankStructureAsArchivedArgs = {
  input: UpdateQBankStructureAsArchivedInput;
};


export type MutationQbsUpdateQBankStructureAsDraftArgs = {
  input: UpdateQBankStructureAsDraftInput;
};


export type MutationQbsUpdateQBankStructureAsPublishedArgs = {
  input: UpdateQBankStructureAsPublishedInput;
};


export type MutationQbsUpdateQBankStructureAsUnpublishedArgs = {
  input: UpdateQBankStructureAsUnpublishedInput;
};


export type MutationQbsUpdateQBankStructureLevelsByQBankStructureIdArgs = {
  input: UpdateQBankStructureLevelsByQBankStructureIdInput;
};


export type MutationQbsUpdateUsersQBankStructureLevelItemContentVisibilityArgs = {
  input: UpdateUsersContentVisibilityInput;
};


export type MutationQctCreateInDevelopmentQuestionArgs = {
  input: CreateInDevelopmentQuestionInput;
  taskId: Scalars['String']['input'];
};


export type MutationQctCreateItemSetArgs = {
  input: CreateItemSetInput;
};


export type MutationQctCreateItemSetWorkflowArgs = {
  input: CreateItemSetInput;
};


export type MutationQctCreateOrUpdateQuestionCommentArgs = {
  input: CreateOrUpdateQuestionCommentInput;
};


export type MutationQctCreateOrUpdateQuestionVerdictArgs = {
  input: CreateOrUpdateQuestionVerdictInput;
};


export type MutationQctCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type MutationQctDeleteItemSetSubQuestionArgs = {
  input: DeleteItemSetSubQuestionInput;
};


export type MutationQctDeleteItemSetSubQuestionWorkflowArgs = {
  input: DeleteItemSetSubQuestionInput;
  taskId: Scalars['String']['input'];
};


export type MutationQctDisableItemSetArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctDisableQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctDuplicateQuestionArgs = {
  input: DuplicateQuestionInput;
};


export type MutationQctExportItemSetArgs = {
  input: ExportItemSetInput;
};


export type MutationQctExportSearchResultsArgs = {
  input: ExportSearchResultsInput;
};


export type MutationQctExportSingleQuestionArgs = {
  input: ExportSingleQuestionInput;
};


export type MutationQctImportQuestionSpreadsheetArgs = {
  input: ImportQuestionSpreadsheetInput;
};


export type MutationQctPublishItemSetArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctPublishQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctSaveItemSetAsDraftArgs = {
  input: SaveItemSetAsDraftInput;
};


export type MutationQctSaveItemSetAsDraftWorkflowArgs = {
  input: SaveItemSetAsDraftInput;
  taskId: Scalars['String']['input'];
};


export type MutationQctSaveItemSetAsUnpublishArgs = {
  input: SaveItemSetAsUnpublishInput;
};


export type MutationQctSaveQuestionAsDraftArgs = {
  input: SaveQuestionAsDraftInput;
};


export type MutationQctSaveQuestionAsInDevelopmentArgs = {
  input: SaveQuestionAsDraftInput;
  taskId: Scalars['String']['input'];
};


export type MutationQctSaveQuestionAsUnpublishArgs = {
  input: SaveQuestionAsUnpublishInput;
};


export type MutationQctUnpublishItemSetArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctUnpublishQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationSuAcceptResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSuAssignUserAppRoleArgs = {
  data: AssignUserAppRoleInput;
};


export type MutationSuCreateAppRoleArgs = {
  data: CreateAppRoleInput;
};


export type MutationSuDeleteAppRoleArgs = {
  data: DeleteAppRoleInput;
};


export type MutationSuLoginArgs = {
  UserLoginInput: UserLoginInput;
};


export type MutationSuLoginTwoFactorArgs = {
  LoginTwoFactorInput: LoginTwoFactorInput;
};


export type MutationSuQuickCreateUserArgs = {
  appRoleIds: InputMaybe<AppRoleIdsInput>;
  quickCreateInput: QuickCreateInput;
};


export type MutationSuResendResetPasswordEmailArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSuResendResetPasswordUserLockedArgs = {
  email: Scalars['String']['input'];
};


export type MutationSuResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSuResetUserTwoFactorArgs = {
  data: ResetUserTwoFactorInput;
};


export type MutationSuUnassignUserAppRolesArgs = {
  data: UnassignUserAppRolesInput;
};


export type MutationSuUnlockUserTwoFactorArgs = {
  data: UnlockUserTwoFactorInput;
};


export type MutationSuUpdateAppRoleArgs = {
  data: UpdateAppRoleInput;
};


export type MutationSuUpdateAppRoleAppPermissionsArgs = {
  appPermissionIds: Array<Scalars['String']['input']>;
  appRoleId: Scalars['String']['input'];
};


export type MutationSuUpdateUserArgs = {
  data: UpdateUserInput;
  userId: Scalars['String']['input'];
};


export type MutationSuUpdateUserStatusArgs = {
  data: UpdateUserStatusInput;
};


export type MutationSuVerifyUserTwoFactorArgs = {
  input: VerifyUserTwoFactorInput;
};


export type MutationUnassignUserAppRoleArgs = {
  data: UnassignUserAppRoleInput;
};


export type MutationUpdateUserAppRoleByNamesArgs = {
  data: UpdateUserAppRoleByNamesInput;
};


export type MutationUpdateUserAppRolesArgs = {
  data: UpdateUserAppRolesInput;
};


export type MutationWflCreateQuestionCreationTaskArgs = {
  createQuestionCreationTaskInput: CreateQuestionCreationTaskInput;
};


export type MutationWflCreateQuestionReviewTaskArgs = {
  createQuestionReviewTaskInput: CreateQuestionReviewTaskInput;
};


export type MutationWflCreateTaskAndSubtasksArgs = {
  createTaskAndSubtasksInput: CreateTaskAndSubtasksInput;
};


export type MutationWflCreateTaskCommentArgs = {
  createTaskCommentInputType: CreateTaskCommentInput;
};


export type MutationWflDeleteSubtaskArgs = {
  deleteSubtaskInput: DeleteSubtaskInput;
};


export type MutationWflSubmitQSetReviewArgs = {
  submitQSetReviewInput: SubmitQSetReviewInput;
};


export type MutationWflSubmitQuestionReviewArgs = {
  submitQuestionReviewInput: SubmitQuestionReviewInput;
};


export type MutationWflUpdateAndCreateSubtasksArgs = {
  updateAndCreateSubtasksInput: UpdateAndCreateSubtasksInput;
};


export type MutationWflUpdateDueDateTaskAndSubtasksArgs = {
  updateDueDateTaskAndSubtasksInput: UpdateDueDateTaskAndSubtasksInput;
};


export type MutationWflUpdateQuestionCreationTaskArgs = {
  updateQuestionCreationTaskInput: UpdateQuestionCreationTaskInput;
};


export type MutationWflUpdateSubtasksArgs = {
  updateSubtasksInput: UpdateSubtasksInput;
};


export type MutationWflUpdateTaskArgs = {
  updateTaskInput: UpdateTaskInput;
};


export type MutationWflUpdateTaskAndSubtasksAndCreateSubtasksArgs = {
  updateTaskAndSubtasksAndCreateSubtasksInput: UpdateTaskAndSubtasksAndCreateSubtasksInput;
};


export type MutationWflUpdateTaskStatusArgs = {
  updateTaskStatusInput: UpdateTaskStatusInput;
};

export enum OperatorType {
  And = 'AND',
  Or = 'OR'
}

export type OrderInput = {
  /** Field to order by */
  field: Scalars['String']['input'];
  type: OrderType;
};

export enum OrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PageInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PassingCriteriaInput = {
  type: QConfigPassingCriteriaType;
  value: Scalars['Int']['input'];
};

export type PublishQConfigInput = {
  qConfigId: Scalars['String']['input'];
};

export type PublishQConfigOutput = {
  __typename?: 'PublishQConfigOutput';
  qConfig: QConfig;
};

export type PublishQSetsInput = {
  qSetIds: Array<Scalars['String']['input']>;
};

export type QBankStructure = {
  __typename?: 'QBankStructure';
  code: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  groupTag: Maybe<Tag>;
  groupTagId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remark: Maybe<Scalars['String']['output']>;
  status: QBankStructureStatus;
  type: QBankStructureType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QBankStructureAuditLog = {
  __typename?: 'QBankStructureAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<QBankStructureAuditLogIdentifier>;
  type: QBankStructureAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type QBankStructureAuditLogFilterConditionInput = {
  field: Scalars['String']['input'];
  operator: FilterOperatorEnum;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type QBankStructureAuditLogIdentifier = {
  __typename?: 'QBankStructureAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: QBankStructureAuditLogIdentifierType;
};

export enum QBankStructureAuditLogIdentifierType {
  LosId = 'LOS_ID',
  QbankStructureId = 'QBANK_STRUCTURE_ID',
  UserId = 'USER_ID'
}

export type QBankStructureAuditLogOrderInput = {
  field: Scalars['String']['input'];
  type: QBankStructureAuditLogOrderType;
};

export enum QBankStructureAuditLogOrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type QBankStructureAuditLogPagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type QBankStructureAuditLogSearchFilterInput = {
  conditions?: InputMaybe<Array<QBankStructureAuditLogFilterConditionInput>>;
  searchText?: InputMaybe<QBankStructureAuditLogSearchTextInput>;
};

export type QBankStructureAuditLogSearchTextInput = {
  fields: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export enum QBankStructureAuditLogType {
  Los = 'LOS',
  QbankStructure = 'QBANK_STRUCTURE',
  QbankStructureLevel = 'QBANK_STRUCTURE_LEVEL',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM',
  Setting = 'SETTING'
}

export type QBankStructureGroupTagInput = {
  name: Scalars['String']['input'];
};

export type QBankStructureLevel = {
  __typename?: 'QBankStructureLevel';
  category: QBankStructureLevelCategory;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  qBankStructureId: Scalars['String']['output'];
};

export enum QBankStructureLevelCategory {
  Chapter = 'CHAPTER',
  Course = 'COURSE',
  Group = 'GROUP',
  Part = 'PART',
  Subject = 'SUBJECT',
  SubTopic = 'SUB_TOPIC',
  Topic = 'TOPIC'
}

export type QBankStructureLevelItem = {
  __typename?: 'QBankStructureLevelItem';
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  parentLevelItemId: Maybe<Scalars['String']['output']>;
  qBankStructureId: Scalars['String']['output'];
  qBankStructureLevel: Maybe<QBankStructureLevel>;
  qBankStructureLevelId: Scalars['String']['output'];
  qId: Maybe<Scalars['String']['output']>;
  tag: Maybe<Tag>;
  tagId: Maybe<Scalars['String']['output']>;
};

export type QBankStructureLevelItemCategory = {
  categories?: InputMaybe<Array<QBankStructureLevelCategory>>;
};

export type QBankStructureLevelItemPartSubject = {
  __typename?: 'QBankStructureLevelItemPartSubject';
  id: Scalars['String']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  parentLevelItemId: Maybe<Scalars['String']['output']>;
  qBankStructureId: Scalars['String']['output'];
  qBankStructureLevelId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type QBankStructureLevelItemsAbility = {
  __typename?: 'QBankStructureLevelItemsAbility';
  id: Scalars['String']['output'];
  isChildrenAddable: Scalars['Boolean']['output'];
};

export enum QBankStructureStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type QBankStructureTask = {
  __typename?: 'QBankStructureTask';
  code: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QBankStructureType {
  Main = 'MAIN',
  Mock = 'MOCK'
}

export enum QBankStructureValidationCase {
  MissingLastLevelItem = 'MISSING_LAST_LEVEL_ITEM',
  MissingNameInInformationItem = 'MISSING_NAME_IN_INFORMATION_ITEM'
}

export type QBankStructuresResult = {
  __typename?: 'QBankStructuresResult';
  qBankStructures: Array<QBankStructure>;
  total: Scalars['Int']['output'];
};

export type QConfig = {
  __typename?: 'QConfig';
  code: Scalars['Float']['output'];
  examCourse: ExamCourse;
  examCourseId: Scalars['String']['output'];
  fullScore: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  metadata: QConfigMetadata;
  name: Scalars['String']['output'];
  passingCriteria: Maybe<QConfigPassingCriteria>;
  qConfigGeneratorResultId: Maybe<Scalars['String']['output']>;
  randomType: Maybe<QConfigRandomType>;
  status: QConfigStatus;
  structures: Array<QConfigStructure>;
  timeLimit: Maybe<QConfigTimeLimit>;
  totalQuestions: Scalars['Int']['output'];
  type: QConfigType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QConfigAuditLog = {
  __typename?: 'QConfigAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<QConfigAuditLogIdentifier>;
  type: QConfigAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type QConfigAuditLogIdentifier = {
  __typename?: 'QConfigAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: QConfigAuditLogIdentifierType;
};

export enum QConfigAuditLogIdentifierType {
  ExaminationCourseId = 'EXAMINATION_COURSE_ID',
  QconfigId = 'QCONFIG_ID',
  QconfigStructureId = 'QCONFIG_STRUCTURE_ID'
}

export enum QConfigAuditLogType {
  Qconfig = 'QCONFIG',
  QconfigStructure = 'QCONFIG_STRUCTURE'
}

export type QConfigCondition = {
  __typename?: 'QConfigCondition';
  questionTypes: Array<QConfigMetadataConditionQuestionType>;
  tags: Array<QConfigConditionTag>;
};

export type QConfigConditionTag = {
  __typename?: 'QConfigConditionTag';
  needTotal: Scalars['Float']['output'];
  tag: ConditionTag;
};

export type QConfigGenerator = {
  __typename?: 'QConfigGenerator';
  code: Scalars['String']['output'];
  examCourseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latestExecution: QConfigGeneratorExecution;
  metadata: QConfigGeneratorMetadata;
  name: Scalars['String']['output'];
  needTotal: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type QConfigGeneratorCondition = {
  __typename?: 'QConfigGeneratorCondition';
  qBankStructureLevelItems: Array<QConfigGeneratorConditionsQBankStructureLevelItem>;
  questionTypes: Array<QConfigGeneratorConditionsQuestionType>;
  tags: Array<QConfigGeneratorConditionsTag>;
};

export type QConfigGeneratorConditionsQBankStructureLevelItem = {
  __typename?: 'QConfigGeneratorConditionsQBankStructureLevelItem';
  needTotal: Scalars['Int']['output'];
  qBankStructureLevelItemId: Scalars['String']['output'];
};

export type QConfigGeneratorConditionsQuestionType = {
  __typename?: 'QConfigGeneratorConditionsQuestionType';
  needTotal: Scalars['Int']['output'];
  type: QConfigQuestionType;
};

export type QConfigGeneratorConditionsTag = {
  __typename?: 'QConfigGeneratorConditionsTag';
  needTotal: Scalars['Int']['output'];
  tag: QConfigGeneratorConditionsTagTagObjectType;
};

export type QConfigGeneratorConditionsTagTagObjectType = {
  __typename?: 'QConfigGeneratorConditionsTagTagObjectType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QConfigGeneratorExecution = {
  __typename?: 'QConfigGeneratorExecution';
  createdAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  needTotal: Scalars['Int']['output'];
  qConfigGeneratorId: Scalars['String']['output'];
  results: Array<QConfigGeneratorExecutionResult>;
  round: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: QConfigGeneratorExecutionStatus;
  totalResults: Scalars['Int']['output'];
};

export type QConfigGeneratorExecutionResult = {
  __typename?: 'QConfigGeneratorExecutionResult';
  id: Scalars['String']['output'];
  qConfig: Maybe<QConfig>;
  qConfigGeneratorExecutionId: Scalars['String']['output'];
};

export enum QConfigGeneratorExecutionStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum QConfigGeneratorGroupLevel {
  Chapter = 'CHAPTER',
  Subject = 'SUBJECT'
}

export type QConfigGeneratorMetadata = {
  __typename?: 'QConfigGeneratorMetadata';
  conditions: QConfigGeneratorCondition;
  generatorGroupLevel: QConfigGeneratorGroupLevel;
  qBankStructureIds: Maybe<Array<Scalars['String']['output']>>;
};

export type QConfigMetadata = {
  __typename?: 'QConfigMetadata';
  conditions: Maybe<QConfigCondition>;
  passingCriteria: Maybe<QConfigPassingCriteria>;
  randomConfig: Maybe<QConfigRandomConfig>;
  timeLimit: Maybe<QConfigTimeLimit>;
};

export type QConfigMetadataConditionQuestionType = {
  __typename?: 'QConfigMetadataConditionQuestionType';
  needTotal: Scalars['Float']['output'];
  type: QConfigQuestionType;
};

export type QConfigPassingCriteria = {
  __typename?: 'QConfigPassingCriteria';
  type: QConfigPassingCriteriaType;
  value: Scalars['Int']['output'];
};

export enum QConfigPassingCriteriaType {
  Percent = 'PERCENT',
  Score = 'SCORE'
}

export enum QConfigQuestionType {
  ItemSet = 'ITEM_SET',
  Single = 'SINGLE'
}

export type QConfigRandomConfig = {
  __typename?: 'QConfigRandomConfig';
  groupBy: Maybe<QConfigRandomGroupBy>;
  type: QConfigRandomConfigType;
};

export enum QConfigRandomConfigType {
  Fixed = 'FIXED',
  Random = 'RANDOM'
}

export enum QConfigRandomGroupBy {
  Hierarchy = 'HIERARCHY',
  Part = 'PART'
}

export enum QConfigRandomType {
  AllRandom = 'ALL_RANDOM',
  Fixed = 'FIXED',
  RandomByHierarchy = 'RANDOM_BY_HIERARCHY',
  RandomByPart = 'RANDOM_BY_PART'
}

export enum QConfigStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type QConfigStructure = {
  __typename?: 'QConfigStructure';
  category: Maybe<QConfigStructureCategory>;
  conditions: Array<QConfigStructureCondition>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  parentRefId: Maybe<Scalars['String']['output']>;
  passingCriteria: Maybe<QConfigStructurePassingCriteria>;
  qConfigId: Scalars['String']['output'];
  refCode: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refSource: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  size: Maybe<Scalars['Int']['output']>;
  totalQuestions: Scalars['Int']['output'];
  type: QConfigStructureType;
};

export enum QConfigStructureCategory {
  AllSubTopic = 'ALL_SUB_TOPIC',
  Chapter = 'CHAPTER',
  Course = 'COURSE',
  Group = 'GROUP',
  ItemSet = 'ITEM_SET',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  NonSpecificTopic = 'NON_SPECIFIC_TOPIC',
  Part = 'PART',
  Single = 'SINGLE',
  Subject = 'SUBJECT',
  SubTopic = 'SUB_TOPIC',
  Topic = 'TOPIC'
}

export type QConfigStructureCondition = QConfigStructureConditionMultiTagGroup | QConfigStructureConditionSingleTagGroup;

export type QConfigStructureConditionMultiTagGroup = {
  __typename?: 'QConfigStructureConditionMultiTagGroup';
  needTotal: Scalars['Int']['output'];
  tagGroups: Array<QConfigStructureConditionTagGroup>;
  type: QConfigStructureConditionType;
};

export type QConfigStructureConditionMultiTagGroupObjectType = {
  __typename?: 'QConfigStructureConditionMultiTagGroupObjectType';
  needTotal: Scalars['Float']['output'];
  tagGroups: Array<QConfigStructureConditionTagGroupObjectType>;
  type: Scalars['String']['output'];
};

export type QConfigStructureConditionObjectType = QConfigStructureConditionMultiTagGroupObjectType | QConfigStructureConditionSingleTagGroupObjectType;

export type QConfigStructureConditionSingleTagGroup = {
  __typename?: 'QConfigStructureConditionSingleTagGroup';
  needTotal: Scalars['Int']['output'];
  tags: Array<ConditionTag>;
  type: QConfigStructureConditionType;
};

export type QConfigStructureConditionSingleTagGroupObjectType = {
  __typename?: 'QConfigStructureConditionSingleTagGroupObjectType';
  needTotal: Scalars['Float']['output'];
  tags: Array<ConditionTagObjectType>;
  type: Scalars['String']['output'];
};

export type QConfigStructureConditionTagGroup = {
  __typename?: 'QConfigStructureConditionTagGroup';
  count: Scalars['Int']['output'];
  tags: Array<ConditionTag>;
};

export type QConfigStructureConditionTagGroupObjectType = {
  __typename?: 'QConfigStructureConditionTagGroupObjectType';
  count: Scalars['Float']['output'];
  tags: Array<ConditionTagObjectType>;
};

export enum QConfigStructureConditionType {
  MultiTagGroup = 'MULTI_TAG_GROUP',
  SingleTagGroup = 'SINGLE_TAG_GROUP'
}

export type QConfigStructureNameInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type QConfigStructurePassingCriteria = {
  __typename?: 'QConfigStructurePassingCriteria';
  type: QConfigPassingCriteriaType;
  value: Scalars['Int']['output'];
};

export type QConfigStructurePassingCriteriaObjectType = {
  __typename?: 'QConfigStructurePassingCriteriaObjectType';
  type: QConfigPassingCriteriaType;
  value: Scalars['Float']['output'];
};

export type QConfigStructureSnapShot = {
  __typename?: 'QConfigStructureSnapShot';
  category: Maybe<QConfigStructureCategory>;
  conditions: Array<QConfigStructureCondition>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  parentRefId: Maybe<Scalars['String']['output']>;
  passingCriteria: Maybe<QConfigStructurePassingCriteria>;
  qConfigId: Scalars['String']['output'];
  refCode: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refSource: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  size: Maybe<Scalars['Int']['output']>;
  totalQuestions: Scalars['Int']['output'];
  type: QConfigStructureType;
};

export enum QConfigStructureType {
  QuestionType = 'QUESTION_TYPE',
  QBankStructure = 'Q_BANK_STRUCTURE',
  QBankStructureLevelItem = 'Q_BANK_STRUCTURE_LEVEL_ITEM',
  QConfig = 'Q_CONFIG',
  Tag = 'TAG'
}

export type QConfigStructuresTask = {
  __typename?: 'QConfigStructuresTask';
  category: Maybe<QConfigStructureCategory>;
  conditions: Array<QConfigStructureConditionObjectType>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  parentRefId: Maybe<Scalars['String']['output']>;
  passingCriteria: Maybe<QConfigStructurePassingCriteriaObjectType>;
  refCode: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refSource: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  size: Maybe<Scalars['Float']['output']>;
  totalQuestions: Scalars['Float']['output'];
  type: QConfigStructureType;
};

export type QConfigTask = {
  __typename?: 'QConfigTask';
  code: Scalars['Int']['output'];
  fullScore: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  metadata: QConfigTaskMetadata;
  structures: Array<QConfigStructuresTask>;
  totalQuestions: Scalars['Float']['output'];
};

export type QConfigTaskMetadata = {
  __typename?: 'QConfigTaskMetadata';
  conditions: Maybe<QConfigTaskMetadataCondition>;
  passingCriteria: Maybe<QConfigTaskMetadataPassingCriteria>;
  randomConfig: Maybe<QConfigTaskMetadataRandomConfig>;
  timeLimit: Maybe<QConfigTaskMetadataTimeLimit>;
};

export type QConfigTaskMetadataCondition = {
  __typename?: 'QConfigTaskMetadataCondition';
  questionTypes: Array<QConfigTaskMetadataConditionQuestion>;
  tags: Array<QConfigTaskMetadataConditionTag>;
};

export type QConfigTaskMetadataConditionQuestion = {
  __typename?: 'QConfigTaskMetadataConditionQuestion';
  needTotal: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type QConfigTaskMetadataConditionTag = {
  __typename?: 'QConfigTaskMetadataConditionTag';
  needTotal: Scalars['Float']['output'];
  tag: TaskQConfigConditionTag;
};

export type QConfigTaskMetadataPassingCriteria = {
  __typename?: 'QConfigTaskMetadataPassingCriteria';
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type QConfigTaskMetadataRandomConfig = {
  __typename?: 'QConfigTaskMetadataRandomConfig';
  groupBy: Maybe<QConfigRandomGroupBy>;
  type: QConfigRandomConfigType;
};

export type QConfigTaskMetadataTimeLimit = {
  __typename?: 'QConfigTaskMetadataTimeLimit';
  total: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  values: Array<QConfigTaskMetadataTimeLimitValue>;
};

export type QConfigTaskMetadataTimeLimitValue = {
  __typename?: 'QConfigTaskMetadataTimeLimitValue';
  order: Scalars['Float']['output'];
  qConfigStructureIds: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['Float']['output'];
};

export type QConfigTimeLimit = {
  __typename?: 'QConfigTimeLimit';
  total: Maybe<Scalars['Int']['output']>;
  type: QConfigTimeLimitType;
  values: Array<QConfigTimeLimitValue>;
};

export enum QConfigTimeLimitType {
  All = 'ALL',
  ByStructure = 'BY_STRUCTURE'
}

export type QConfigTimeLimitValue = {
  __typename?: 'QConfigTimeLimitValue';
  order: Scalars['Int']['output'];
  qConfigStructureIds: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['Int']['output'];
};

export enum QConfigType {
  Manual = 'MANUAL',
  ManualOptimized = 'MANUAL_OPTIMIZED',
  Optimized = 'OPTIMIZED'
}

export type QContentAuditLogFilterConditionInput = {
  field: Scalars['String']['input'];
  operator: FilterOperatorEnum;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type QContentAuditLogIdentifier = {
  __typename?: 'QContentAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: QContentAuditLogIdentifierType;
};

export enum QContentAuditLogIdentifierType {
  QbankStructureId = 'QBANK_STRUCTURE_ID',
  QcontentId = 'QCONTENT_ID',
  QuestionGroupId = 'QUESTION_GROUP_ID'
}

export type QContentAuditLogObjectType = {
  __typename?: 'QContentAuditLogObjectType';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<QContentAuditLogIdentifier>;
  type: QContentAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type QContentAuditLogOrderInput = {
  field: Scalars['String']['input'];
  type: QContentAuditLogOrderType;
};

export enum QContentAuditLogOrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type QContentAuditLogPagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type QContentAuditLogSearchFilterInput = {
  conditions?: InputMaybe<Array<QContentAuditLogFilterConditionInput>>;
  searchText?: InputMaybe<QContentAuditLogSearchTextInput>;
};

export type QContentAuditLogSearchTextInput = {
  fields: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export enum QContentAuditLogType {
  Question = 'QUESTION',
  QuestionGroup = 'QUESTION_GROUP'
}

export type QSet = {
  __typename?: 'QSet';
  assignees: Array<RawUser>;
  code: Scalars['String']['output'];
  conditions: Maybe<QSetConditions>;
  disabledAt: Maybe<Scalars['DateTime']['output']>;
  disabledBy: Maybe<Scalars['String']['output']>;
  duplicationRate: Scalars['Float']['output'];
  examCourseId: Scalars['String']['output'];
  examUsageStatus: Maybe<ExamUsageStatus>;
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  lastReviewedAt: Maybe<Scalars['DateTime']['output']>;
  metadata: Maybe<QSetMetadata>;
  pAvgValue: Scalars['Float']['output'];
  qConfig: QConfig;
  qConfigId: Scalars['String']['output'];
  qSetGeneratorExecutionId: Maybe<Scalars['String']['output']>;
  qSetGeneratorExecutionResultId: Maybe<Scalars['String']['output']>;
  qSetGeneratorId: Maybe<Scalars['String']['output']>;
  status: QSetStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type QSetAuditLog = {
  __typename?: 'QSetAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<QSetAuditLogIdentifier>;
  type: QSetAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type QSetAuditLogIdentifier = {
  __typename?: 'QSetAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: QSetAuditLogIdentifierType;
};

export enum QSetAuditLogIdentifierType {
  ExaminationCourseId = 'EXAMINATION_COURSE_ID',
  QsetId = 'QSET_ID',
  QsetQuestionId = 'QSET_QUESTION_ID'
}

export enum QSetAuditLogType {
  Qset = 'QSET'
}

export type QSetComparisonInput = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export enum QSetConditionQuestionType {
  ItemSet = 'ITEM_SET',
  Single = 'SINGLE'
}

export type QSetConditionTag = {
  __typename?: 'QSetConditionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QSetConditions = {
  __typename?: 'QSetConditions';
  averagePValue: Scalars['Float']['output'];
  questionTypes: Array<QSetConditionsQuestionType>;
  tags: Array<QSetConditionsTags>;
};

export type QSetConditionsQuestionType = {
  __typename?: 'QSetConditionsQuestionType';
  count: Scalars['Int']['output'];
  type: QSetConditionQuestionType;
};

export type QSetConditionsTags = {
  __typename?: 'QSetConditionsTags';
  count: Scalars['Int']['output'];
  tag: QSetConditionTag;
};

export type QSetGenerator = {
  __typename?: 'QSetGenerator';
  code: Scalars['String']['output'];
  duplicationRate: Scalars['Float']['output'];
  examCourseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  needTotal: Scalars['Int']['output'];
  qConfig: QConfig;
  qConfigId: Scalars['String']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type QSetGeneratorExecution = {
  __typename?: 'QSetGeneratorExecution';
  endedAt: Maybe<Scalars['DateTime']['output']>;
  generator: QSetGenerator;
  id: Scalars['String']['output'];
  qSetGeneratorId: Scalars['String']['output'];
  results: Array<QSetGeneratorExecutionResult>;
  round: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: QSetGeneratorExecutionStatus;
};

export type QSetGeneratorExecutionResult = {
  __typename?: 'QSetGeneratorExecutionResult';
  averageDuplicationRate: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  criteriaResult: QSetGeneratorExecutionResultCriteriaResult;
  id: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pAvgValue: Scalars['Float']['output'];
  qSetGeneratorExecutionId: Scalars['String']['output'];
  questionDetails: Array<QuestionDetailsResult>;
};

export enum QSetGeneratorExecutionResultCriteriaResult {
  Failed = 'FAILED',
  Passed = 'PASSED'
}

export enum QSetGeneratorExecutionStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type QSetMetadata = {
  __typename?: 'QSetMetadata';
  assigneeIds: Maybe<Array<Scalars['String']['output']>>;
  passingCriteria: Maybe<QSetPassingCriteria>;
  qConfigStructureParts: Maybe<Array<QConfigStructureSnapShot>>;
  qConfigStructures: Maybe<Array<QConfigStructureSnapShot>>;
  randomType: Maybe<QConfigRandomType>;
};

export type QSetPassingCriteria = {
  __typename?: 'QSetPassingCriteria';
  byStructure: Array<QSetPassingCriteriaByStructure>;
  total: Scalars['Int']['output'];
};

export type QSetPassingCriteriaByStructure = {
  __typename?: 'QSetPassingCriteriaByStructure';
  qConfigStructureId: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type QSetQuestion = {
  __typename?: 'QSetQuestion';
  groupOrder: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  metadata: QSetQuestionMetadata;
  order: Scalars['Float']['output'];
  qSet: QSet;
  qSetId: Scalars['String']['output'];
  question: Maybe<Question>;
  questionGroup: Maybe<QuestionGroup>;
  questionGroupId: Scalars['String']['output'];
  questionGroupType: QSetQuestionGroupType;
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
  questionSnapshot: Maybe<QSetQuestionSnapshot>;
  score: Scalars['Float']['output'];
};

export type QSetQuestionGroupSnapshot = {
  __typename?: 'QSetQuestionGroupSnapshot';
  id: Scalars['String']['output'];
  metadata: Maybe<QSetQuestionGroupSnapshotMetadata>;
  name: Scalars['String']['output'];
  qSetId: Scalars['String']['output'];
  questionGroupId: Scalars['String']['output'];
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  size: Maybe<Scalars['Float']['output']>;
  type: QSetQuestionGroupSnapshotType;
};

export type QSetQuestionGroupSnapshotMetadata = {
  __typename?: 'QSetQuestionGroupSnapshotMetadata';
  paragraph: Maybe<Scalars['String']['output']>;
};

export enum QSetQuestionGroupSnapshotType {
  ItemSet = 'ITEM_SET',
  LotOfQuestion = 'LOT_OF_QUESTION',
  Single = 'SINGLE'
}

/** Question Group Type */
export enum QSetQuestionGroupType {
  ItemSet = 'ITEM_SET',
  LotOfQuestion = 'LOT_OF_QUESTION',
  Single = 'SINGLE'
}

export type QSetQuestionMetadata = {
  __typename?: 'QSetQuestionMetadata';
  qConfigStructures: Array<QSetQuestionQConfigStructure>;
};

export type QSetQuestionQConfigStructure = {
  __typename?: 'QSetQuestionQConfigStructure';
  category: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum QSetQuestionQuestionSnapshotOwnerType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export enum QSetQuestionQuestionSnapshotSolutionType {
  Html = 'HTML'
}

export enum QSetQuestionQuestionSnapshotType {
  MultipleChoice = 'MULTIPLE_CHOICE'
}

export type QSetQuestionSnapshot = {
  __typename?: 'QSetQuestionSnapshot';
  bIndexValue: Maybe<Scalars['Float']['output']>;
  correctAnswer: QuestionSnapshotCorrectAnswer;
  createdBy: Scalars['String']['output'];
  details: Scalars['String']['output'];
  groupOrder: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastPublishedAt: Scalars['DateTime']['output'];
  lastPublishedBy: Scalars['String']['output'];
  metadata: QSetQuestionSnapshotMetadata;
  pValue: Scalars['Float']['output'];
  qSetQuestionId: Scalars['String']['output'];
  questionGroup: Maybe<QSetQuestionGroupSnapshot>;
  questionGroupSnapshotId: Scalars['String']['output'];
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  solution: QSetQuestionSnapshotSolution;
  tags: Array<QSetQuestionSnapshotTag>;
  type: QSetQuestionQuestionSnapshotType;
};

export type QSetQuestionSnapshotChoice = {
  __typename?: 'QSetQuestionSnapshotChoice';
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type QSetQuestionSnapshotMetadata = {
  __typename?: 'QSetQuestionSnapshotMetadata';
  audit1: Maybe<Scalars['String']['output']>;
  audit2: Maybe<Scalars['String']['output']>;
  audit3: Maybe<Scalars['String']['output']>;
  choices: Array<QSetQuestionSnapshotChoice>;
  owner: Maybe<QSetQuestionSnapshotOwner>;
  questionStructures: Array<QuestionSnapshotStructure>;
  reference: Scalars['String']['output'];
  tags: Array<QSetQuestionSnapshotTag>;
};

export type QSetQuestionSnapshotOwner = {
  __typename?: 'QSetQuestionSnapshotOwner';
  type: QSetQuestionQuestionSnapshotOwnerType;
  value: Maybe<Scalars['String']['output']>;
};

export type QSetQuestionSnapshotSolution = {
  __typename?: 'QSetQuestionSnapshotSolution';
  type: QSetQuestionQuestionSnapshotSolutionType;
  value: Scalars['String']['output'];
};

export type QSetQuestionSnapshotTag = {
  __typename?: 'QSetQuestionSnapshotTag';
  category: QSetQuestionSnapshotTagCategory;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QSetQuestionSnapshotTagCategory {
  Calculation = 'CALCULATION',
  CognitiveDomain = 'COGNITIVE_DOMAIN',
  Difficulty = 'DIFFICULTY',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevel = 'QBANK_STRUCTURE_LEVEL'
}

export type QSetReviewCommentOutput = {
  __typename?: 'QSetReviewCommentOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType: ExaminationEntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: RawUser;
  userId: Scalars['String']['output'];
};

export type QSetReviewQuestionOutput = {
  __typename?: 'QSetReviewQuestionOutput';
  groupOrder: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  qSetId: Scalars['String']['output'];
  questionGroupId: Scalars['String']['output'];
  questionGroupType: QSetQuestionGroupType;
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type QSetReviewTaskResultOutput = {
  __typename?: 'QSetReviewTaskResultOutput';
  comment: Maybe<QSetReviewCommentOutput>;
  question: QSetReviewQuestionOutput;
  totalComments: Scalars['Float']['output'];
  verdict: Maybe<QSetReviewVerdictOutput>;
};

export type QSetReviewVerdictOutput = {
  __typename?: 'QSetReviewVerdictOutput';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType: ExaminationEntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  verdict: Maybe<Verdict>;
};

export type QSetSimilarityResultOutput = {
  __typename?: 'QSetSimilarityResultOutput';
  duplicatedQuestionIds: Array<Scalars['String']['output']>;
  duplicationCount: Scalars['Float']['output'];
  duplicationRate: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  qSetA: Scalars['String']['output'];
  qSetACode: Scalars['String']['output'];
  qSetAUpdatedAt: Scalars['DateTime']['output'];
  qSetB: Scalars['String']['output'];
  qSetBCode: Scalars['String']['output'];
  qSetBUpdatedAt: Scalars['DateTime']['output'];
  totalQuestions: Scalars['Float']['output'];
};

export type QSetSimilarityResultWithQuestionsOutput = {
  __typename?: 'QSetSimilarityResultWithQuestionsOutput';
  duplicatedQuestionIds: Array<Scalars['String']['output']>;
  duplicatedQuestions: Array<QSetQuestion>;
  duplicationCount: Scalars['Float']['output'];
  duplicationRate: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  qSetA: Scalars['String']['output'];
  qSetACode: Scalars['String']['output'];
  qSetAUpdatedAt: Scalars['DateTime']['output'];
  qSetB: Scalars['String']['output'];
  qSetBCode: Scalars['String']['output'];
  qSetBUpdatedAt: Scalars['DateTime']['output'];
  totalQuestions: Scalars['Float']['output'];
};

export enum QSetStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Published = 'PUBLISHED',
  Reviewed = 'REVIEWED',
  Unpublished = 'UNPUBLISHED'
}

export type QSetTask = {
  __typename?: 'QSetTask';
  code: Scalars['String']['output'];
  duplicationRate: Scalars['Float']['output'];
  examCourse: ExamCourseTask;
  examCourseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  pAvgValue: Scalars['Float']['output'];
  qConfig: QConfigTask;
  qConfigId: Scalars['String']['output'];
  qSetGeneratorExecutionId: Maybe<Scalars['String']['output']>;
  qSetGeneratorExecutionResultId: Maybe<Scalars['String']['output']>;
  qSetGeneratorId: Maybe<Scalars['String']['output']>;
  status: QSetTaskStatus;
};

export type QSetTaskReviewSummaryOutput = {
  __typename?: 'QSetTaskReviewSummaryOutput';
  comments: Array<QSetReviewCommentOutput>;
  question: QSetReviewQuestionOutput;
  totalComments: Scalars['Float']['output'];
  verdicts: Array<QSetReviewVerdictOutput>;
};

export enum QSetTaskStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Published = 'PUBLISHED',
  Reviewed = 'REVIEWED',
  Unpublished = 'UNPUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  UsBoGetTokenStatus: UsBoGetTokenStatusResponse;
  UsBoSearchUsersWithAppRoleFilters: UsBoUserSearchResult;
  UsBoUser: UsBoUser;
  UsBoUsers: UsBoUserSearchResult;
  cvSearchUsersContentVisibility: UsersDataContentVisibilityResult;
  excExportQSet: ExportQSetOutput;
  excExportTaskQSet: ExportQSetOutput;
  excGetDisabledLearningObjectiveStatementsByQConfigId: GetDisabledLearningObjectiveStatementsByQConfigIdOutput;
  excGetDownloadSignedUrlForExamCourseComment: GetDownloadSignedUrlForExamCourseCommentOutput;
  excGetDownloadSignedUrlForQuestionsByQSetId: GetDownloadSignedUrlForQuestionsByQSetIdOutput;
  excGetExamCourseById: GetExamCourseByIdOutput;
  excGetExamCourseComments: GetExamCourseCommentsOutput;
  excGetExamCourseGroupById: GetExamCourseGroupByIdOutput;
  excGetExamCourseVerdict: GetExamCourseVerdictOutput;
  excGetQConfigById: GetQConfigByIdOutput;
  excGetQConfigGeneratorById: GetQConfigGeneratorByIdOutput;
  excGetQSetById: GetQSetByIdOutput;
  excGetQSetByTaskId: GetQSetByTaskIdOutput;
  excGetQSetGeneratorExecutionById: GetQSetGeneratorExecutionByIdOutput;
  excGetQSetQuestionsByQuestionIds: GetQSetQuestionsByQuestionIdsOutput;
  excGetQSetQuestionsByTaskId: GetQSetQuestionsByTaskIdOutput;
  excGetQSetSimilarities: GetQSetSimilaritiesOutput;
  excGetQSetSimilarityWithQuestionsById: GetQSetSimilarityByIdOutput;
  excGetUploadSignedUrlForExamCourseComment: GetUploadSignedUrlForExamCourseCommentOutput;
  excRandomPreviewQuestionsByTaskId: RandomPreviewQuestionsByTaskIdOutput;
  excSearchExamCourseGroupsByName: SearchExamCourseGroupsByNameOutput;
  excSearchExamCourses: SearchExamCoursesOutput;
  excSearchQConfigAuditLog: SearchQConfigAuditLogOutput;
  excSearchQConfigGenerators: SearchQConfigGeneratorsOutput;
  excSearchQConfigs: SearchQConfigsOutput;
  excSearchQSetAuditLog: SearchQSetAuditLogOutput;
  excSearchQSetQuestions: SearchQSetQuestionsOutput;
  excSearchQSets: SearchQSetsOutput;
  excSearchTaskQSetQuestions: SearchQSetQuestionsOutput;
  getAppPermissions: Array<AppPermission>;
  getAppRoleAppPermissions: Array<AppPermission>;
  getAppRoles: AppRoleSearchResult;
  getMyProfile: UsUser;
  getUserAppRoleView: UserAppRoleViewSearchResult;
  qbsCountQBankStructureLevelItemsByQBankStructureIdAndLevelCategory: Scalars['Int']['output'];
  qbsGetLearningObjectiveStatementById: LearningObjectiveStatement;
  qbsGetQBankStructureById: QBankStructure;
  qbsGetQBankStructureGroupTagById: Tag;
  qbsGetQBankStructureLevelItemChildrenById: Array<QBankStructureLevelItem>;
  qbsGetQBankStructureLevelItemsAbilityByQBankStructureId: Array<QBankStructureLevelItemsAbility>;
  qbsGetQBankStructureLevelItemsByQBankStructureId: Array<QBankStructureLevelItem>;
  qbsGetQBankStructureLevelItemsByQBankStructureIdAndUserId: Array<QBankStructureLevelItemPartSubject>;
  qbsGetQBankStructureLevelsByQBankStructureId: Array<QBankStructureLevel>;
  qbsGetQBankStructuresByIds: Array<QBankStructure>;
  qbsGetTagsByCategory: Array<Tag>;
  qbsGetTaskQBankStructureLevelItemsByQBankStructureId: Array<QBankStructureLevelItem>;
  qbsGetTaskQBankStructureLevelsByQBankStructureId: Array<QBankStructureLevel>;
  qbsSearchLearningObjectiveStatements: LearningObjectiveStatementsResult;
  qbsSearchQBankStructureAuditLogs: SearchQBankStructureAuditLogOutput;
  qbsSearchQBankStructureGroupTags: TagResult;
  qbsSearchQBankStructures: QBankStructuresResult;
  qbsSearchTags: TagResult;
  qbsSearchTaskLearningObjectiveStatements: LearningObjectiveStatementsResult;
  qbsSearchTaskTags: TagResult;
  qbsValidateQBankStructureBeforePublish: Array<ValidateQBankStructureResult>;
  qctGetDownloadSignedUrlForQuestionGroups: GetDownloadSignedUrlForQuestionGroupsResult;
  qctGetDownloadSignedUrlForQuestions: GetDownloadSignedUrlForQuestionsResult;
  qctGetDownloadSignedUrlForTaskQuestion: GetDownloadSignedUrlsResult;
  qctGetDownloadSignedUrlForTaskQuestionGroups: GetDownloadSignedUrlForQuestionGroupsResult;
  qctGetDownloadSignedUrlForTaskQuestions: GetDownloadSignedUrlForQuestionsResult;
  qctGetDownloadSignedUrlQuestion: GetDownloadSignedUrlsResult;
  qctGetItemSetQuestionPropertiesByStatusAndLocation: Array<ItemSetQuestionPropertiesByLocation>;
  qctGetItemSetQuestionPropertiesCountByLocation: Array<ItemSetQuestionProperties>;
  qctGetQuestionById: Question;
  qctGetQuestionCommentsByEntityAndTaskId: Array<QuestionComment>;
  qctGetQuestionGroupById: QuestionGroup;
  qctGetQuestionGroupsByQBankStructureLevelItemId: Array<QuestionGroup>;
  qctGetQuestionUsageById: Array<GetQuestionUsageByIdOutput>;
  qctGetQuestionVerdictsByEntityAndTaskId: Array<QuestionVerdict>;
  qctGetQuestionVerdictsByTaskId: Array<QuestionVerdict>;
  qctGetSingleQuestionPropertiesByStatusAndLocation: Array<SingleQuestionPropertiesByLocation>;
  qctGetSingleQuestionPropertiesCountByLocation: Array<SingleQuestionProperties>;
  qctGetSingleQuestionQuestionGroupPropertiesByStatusAndLocation: Array<SingleQuestionQuestionGroupPropertiesByLocation>;
  qctGetTaskQuestionById: Question;
  qctGetTaskQuestionGroupById: QuestionGroup;
  qctGetTaskQuestionGroupByIds: Array<QuestionGroup>;
  qctGetTaskQuestionVerdicts: Array<QuestionVerdict>;
  qctGetTaskQuestionsByIds: Array<Question>;
  qctGetUploadSignedUrlForTaskQuestion: GetUploadSignedUrlResult;
  qctGetUploadSignedUrlImportQuestionSpreadsheet: GetUploadSignedUrlResult;
  qctGetUploadSignedUrlQuestion: GetUploadSignedUrlResult;
  qctSearchQContentAuditLogs: SearchQContentAuditLogOutput;
  qctSearchQuestionGroups: QuestionGroupsResult;
  qctSearchQuestions: QuestionsResult;
  qctSearchQuestionsByKeyword: QuestionKeywordSearchResultDto;
  qctSearchQuestionsByQIds: SearchQuestionsByQIdsResultDto;
  qctSearchQuestionsInLearningObjectiveStatement: QuestionsResult;
  suGetAppRole: GetAppRoleOutputObjectType;
  suUser: GetUserByIdOutputObjectType;
  validateToken: ValidateTokenResult;
  wflGetDownloadSignedUrlForTask: GetDownloadSignedUrlForTaskOutput;
  wflGetMyTasks: GetMyTasksOutput;
  wflGetQSetTaskReviewSummary: GetQSetTaskReviewSummaryOutput;
  wflGetStepTransitionsByTaskId: GetStepTransitionsByTaskIdOutput;
  wflGetTaskById: GetTaskByIdOutput;
  wflGetTaskComments: GetTaskCommentsOutput;
  wflGetTaskReviewResults: GetTaskReviewResultsOutput;
  wflGetTaskVerdict: GetTaskVerdictOutput;
  wflGetTasksByEntityWithParent: GetTasksByEntityWithParentOutput;
  wflGetUploadSignedUrlForQuestionCreationTask: GetUploadSignedUrlForQuestionCreationTaskOutput;
  wflGetUploadSignedUrlForTask: GetUploadSignedUrlForTaskOutput;
  wflSearchMyTasks: SearchMyTasksOutput;
  wflSearchOwnedAndAssignedTasks: SearchOwnedAndAssignedTasksOutput;
};


export type QueryUsBoSearchUsersWithAppRoleFiltersArgs = {
  appRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
  appRoleNames: InputMaybe<Array<Scalars['String']['input']>>;
  excludeAppRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
  excludeFields: InputMaybe<UsBoUserExcludeFieldsInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search?: InputMaybe<UsBoUserSearchInput>;
};


export type QueryUsBoUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsBoUsersArgs = {
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search: InputMaybe<UsBoUserSearchInput>;
};


export type QueryCvSearchUsersContentVisibilityArgs = {
  input: SearchUsersContentVisibilityInput;
};


export type QueryExcExportQSetArgs = {
  input: ExportQSetInput;
};


export type QueryExcExportTaskQSetArgs = {
  input: ExportTaskQSetInput;
};


export type QueryExcGetDisabledLearningObjectiveStatementsByQConfigIdArgs = {
  GetDisabledLearningObjectiveStatementsByQConfigIdInput: GetDisabledLearningObjectiveStatementsByQConfigIdInput;
};


export type QueryExcGetDownloadSignedUrlForExamCourseCommentArgs = {
  GetDownloadSignedUrlForExamCourseCommentInput: GetDownloadSignedUrlForExamCourseCommentInput;
};


export type QueryExcGetDownloadSignedUrlForQuestionsByQSetIdArgs = {
  input: GetDownloadSignedUrlForQuestionsByQSetIdInput;
};


export type QueryExcGetExamCourseByIdArgs = {
  getExamCourseByIdInput: GetExamCourseByIdInput;
};


export type QueryExcGetExamCourseCommentsArgs = {
  GetExamCourseCommentsInput: GetExamCourseCommentsInput;
};


export type QueryExcGetExamCourseGroupByIdArgs = {
  getExamCourseGroupByIdInput: GetExamCourseGroupByIdInput;
};


export type QueryExcGetExamCourseVerdictArgs = {
  GetExamCourseVerdictInput: GetExamCourseVerdictInput;
};


export type QueryExcGetQConfigByIdArgs = {
  getQConfigByIdInput: GetQConfigByIdInput;
};


export type QueryExcGetQConfigGeneratorByIdArgs = {
  getQConfigGeneratorByIdInput: GetQConfigGeneratorByIdInput;
};


export type QueryExcGetQSetByIdArgs = {
  input: GetQSetByIdInput;
};


export type QueryExcGetQSetByTaskIdArgs = {
  input: GetQSetByTaskIdInput;
};


export type QueryExcGetQSetGeneratorExecutionByIdArgs = {
  GetQSetGeneratorExecutionByIdInput: GetQSetGeneratorExecutionByIdInput;
};


export type QueryExcGetQSetQuestionsByQuestionIdsArgs = {
  input: GetQsetQuestionsByQuestionIdsInput;
};


export type QueryExcGetQSetQuestionsByTaskIdArgs = {
  input: GetQSetQuestionsByTaskIdInput;
};


export type QueryExcGetQSetSimilaritiesArgs = {
  input: GetQSetSimilaritiesInput;
};


export type QueryExcGetQSetSimilarityWithQuestionsByIdArgs = {
  input: GetQSetSimilarityByIdInput;
};


export type QueryExcGetUploadSignedUrlForExamCourseCommentArgs = {
  GetUploadSignedUrlForExamCourseCommentInput: GetUploadSignedUrlForExamCourseCommentInput;
};


export type QueryExcRandomPreviewQuestionsByTaskIdArgs = {
  input: RandomPreviewQuestionsByTaskIdInput;
};


export type QueryExcSearchExamCourseGroupsByNameArgs = {
  searchExamCourseGroupsByNameInput: SearchExamCourseGroupsByNameInput;
};


export type QueryExcSearchExamCoursesArgs = {
  searchExamCoursesInput: SearchExamCoursesInput;
};


export type QueryExcSearchQConfigAuditLogArgs = {
  SearchQConfigAuditLogInput: SearchQConfigAuditLogInput;
};


export type QueryExcSearchQConfigGeneratorsArgs = {
  searchQConfigGeneratorsInput: SearchQConfigGeneratorsInput;
};


export type QueryExcSearchQConfigsArgs = {
  searchQConfigsInput: SearchQConfigsInput;
};


export type QueryExcSearchQSetAuditLogArgs = {
  SearchQSetAuditLogInput: SearchQSetAuditLogInput;
};


export type QueryExcSearchQSetQuestionsArgs = {
  input: SearchQSetQuestionsInput;
};


export type QueryExcSearchQSetsArgs = {
  searchQSetsInput: SearchQSetsInput;
};


export type QueryExcSearchTaskQSetQuestionsArgs = {
  input: SearchQSetQuestionsInputWithTaskIdInput;
};


export type QueryGetAppRoleAppPermissionsArgs = {
  appRoleId: Scalars['String']['input'];
};


export type QueryGetAppRolesArgs = {
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search: InputMaybe<AppRoleSearchInput>;
};


export type QueryGetUserAppRoleViewArgs = {
  appRoleId: InputMaybe<Scalars['String']['input']>;
  invertRoleFilter?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search?: InputMaybe<SearchInput>;
};


export type QueryQbsCountQBankStructureLevelItemsByQBankStructureIdAndLevelCategoryArgs = {
  levelCategory: QBankStructureLevelCategory;
  qBankStructureId: Scalars['String']['input'];
};


export type QueryQbsGetLearningObjectiveStatementByIdArgs = {
  input: GetLearningObjectiveStatementByIdInput;
};


export type QueryQbsGetQBankStructureByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureGroupTagByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelItemChildrenByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelItemsAbilityByQBankStructureIdArgs = {
  qBankStructureId: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelItemsByQBankStructureIdArgs = {
  options: InputMaybe<GetQBankStructureLevelItemsByQBankStructureIdOptions>;
  qBankStructureId: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelItemsByQBankStructureIdAndUserIdArgs = {
  options: InputMaybe<QBankStructureLevelItemCategory>;
  qBankStructureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelsByQBankStructureIdArgs = {
  qBankStructureId: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructuresByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryQbsGetTagsByCategoryArgs = {
  getTagsByCategoryInput: GetTagsByCategoryInput;
};


export type QueryQbsGetTaskQBankStructureLevelItemsByQBankStructureIdArgs = {
  options: InputMaybe<GetQBankStructureLevelItemsByQBankStructureIdOptions>;
  qBankStructureId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryQbsGetTaskQBankStructureLevelsByQBankStructureIdArgs = {
  qBankStructureId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryQbsSearchLearningObjectiveStatementsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchLearningObjectiveStatementsInput;
};


export type QueryQbsSearchQBankStructureAuditLogsArgs = {
  input: SearchQBankStructureAuditLogsInputType;
};


export type QueryQbsSearchQBankStructureGroupTagsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchQBankStructureGroupTagInput;
};


export type QueryQbsSearchQBankStructuresArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchQBankStructureInput;
};


export type QueryQbsSearchTagsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchTagsInput;
};


export type QueryQbsSearchTaskLearningObjectiveStatementsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchLearningObjectiveStatementsInput;
  taskId: Scalars['String']['input'];
};


export type QueryQbsSearchTaskTagsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search: SearchTaskTagsInput;
  taskId: Scalars['String']['input'];
};


export type QueryQbsValidateQBankStructureBeforePublishArgs = {
  input: ValidateQBankStructureBeforePublishInput;
};


export type QueryQctGetDownloadSignedUrlForQuestionGroupsArgs = {
  input: GetDownloadSignedUrlForQuestionGroupsInput;
};


export type QueryQctGetDownloadSignedUrlForQuestionsArgs = {
  input: GetDownloadSignedUrlForQuestionsInput;
};


export type QueryQctGetDownloadSignedUrlForTaskQuestionArgs = {
  input: GetDownloadSignedUrlQuestionInput;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetDownloadSignedUrlForTaskQuestionGroupsArgs = {
  input: GetDownloadSignedUrlForQuestionGroupsInput;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetDownloadSignedUrlForTaskQuestionsArgs = {
  input: GetDownloadSignedUrlForQuestionsInput;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetDownloadSignedUrlQuestionArgs = {
  input: GetDownloadSignedUrlQuestionInput;
};


export type QueryQctGetItemSetQuestionPropertiesByStatusAndLocationArgs = {
  input: GetItemSetQuestionPropertiesByStatusAndLocationInputType;
};


export type QueryQctGetItemSetQuestionPropertiesCountByLocationArgs = {
  input: GetItemSetQuestionPropertiesCountByLocationInputType;
};


export type QueryQctGetQuestionByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQctGetQuestionCommentsByEntityAndTaskIdArgs = {
  input: GetQuestionCommentsByEntityAndTaskIdInput;
};


export type QueryQctGetQuestionGroupByIdArgs = {
  questionGroupId: Scalars['String']['input'];
};


export type QueryQctGetQuestionGroupsByQBankStructureLevelItemIdArgs = {
  input: GetQuestionGroupsByQBankStructureLevelItemIdInput;
};


export type QueryQctGetQuestionUsageByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQctGetQuestionVerdictsByEntityAndTaskIdArgs = {
  input: GetQuestionVerdictsByEntityAndTaskIdInput;
};


export type QueryQctGetQuestionVerdictsByTaskIdArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryQctGetSingleQuestionPropertiesByStatusAndLocationArgs = {
  input: GetSingleQuestionPropertiesByStatusAndLocationInputType;
};


export type QueryQctGetSingleQuestionPropertiesCountByLocationArgs = {
  input: GetSingleQuestionPropertiesCountByLocationInput;
};


export type QueryQctGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationArgs = {
  input: GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationInputType;
};


export type QueryQctGetTaskQuestionByIdArgs = {
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryQctGetTaskQuestionGroupByIdArgs = {
  questionGroupId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryQctGetTaskQuestionGroupByIdsArgs = {
  questionGroupIds: Array<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetTaskQuestionVerdictsArgs = {
  input: GetTaskQuestionVerdictsInput;
};


export type QueryQctGetTaskQuestionsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetUploadSignedUrlForTaskQuestionArgs = {
  input: GetUploadSignedUrlQuestionInput;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetUploadSignedUrlImportQuestionSpreadsheetArgs = {
  input: GetUploadSignedUrlImportQuestionSpreadsheetInput;
};


export type QueryQctGetUploadSignedUrlQuestionArgs = {
  input: GetUploadSignedUrlQuestionInput;
};


export type QueryQctSearchQContentAuditLogsArgs = {
  input: SearchQContentAuditLogsInputType;
};


export type QueryQctSearchQuestionGroupsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchQuestionGroupsInput;
};


export type QueryQctSearchQuestionsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchQuestionsInput;
};


export type QueryQctSearchQuestionsByKeywordArgs = {
  input: SearchQuestionsByKeywordInput;
  paging?: PageInput;
};


export type QueryQctSearchQuestionsByQIdsArgs = {
  input: SearchQuestionsByQIdsInput;
  paging?: PageInput;
};


export type QueryQctSearchQuestionsInLearningObjectiveStatementArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search: SearchQuestionsInLearningObjectiveStatementInput;
};


export type QuerySuGetAppRoleArgs = {
  appRoleId: Scalars['String']['input'];
};


export type QuerySuUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidateTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryWflGetDownloadSignedUrlForTaskArgs = {
  input: GetDownloadSignedUrlForTaskInput;
};


export type QueryWflGetMyTasksArgs = {
  getMyTasksInput: GetMyTasksInput;
};


export type QueryWflGetQSetTaskReviewSummaryArgs = {
  getQSetTaskReviewSummaryInput: GetQSetTaskReviewSummaryInput;
};


export type QueryWflGetStepTransitionsByTaskIdArgs = {
  getStepTransitionsByTaskIdInput: GetStepTransitionsByTaskIdInput;
};


export type QueryWflGetTaskByIdArgs = {
  getTaskByIdInput: GetTaskByIdInput;
};


export type QueryWflGetTaskCommentsArgs = {
  getTaskCommentsInputType: GetTaskCommentsInput;
};


export type QueryWflGetTaskReviewResultsArgs = {
  getTaskReviewResultsInput: GetTaskReviewResultsInput;
};


export type QueryWflGetTaskVerdictArgs = {
  getTaskVerdictInput: GetTaskVerdictInput;
};


export type QueryWflGetTasksByEntityWithParentArgs = {
  getTasksByEntityWithParentInput: GetTasksByEntityInput;
};


export type QueryWflGetUploadSignedUrlForQuestionCreationTaskArgs = {
  input: GetUploadSignedUrlForQuestionCreationTaskInput;
};


export type QueryWflGetUploadSignedUrlForTaskArgs = {
  input: GetUploadSignedUrlForTaskInput;
};


export type QueryWflSearchMyTasksArgs = {
  searchMyTasksInput: SearchMyTasksInput;
};


export type QueryWflSearchOwnedAndAssignedTasksArgs = {
  searchOwnedAndAssignedTasksInput: SearchOwnedAndAssignedTasksInput;
};

export type Question = {
  __typename?: 'Question';
  bIndexValue: Maybe<Scalars['Float']['output']>;
  correctAnswer: QuestionCorrectAnswer;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  details: Scalars['String']['output'];
  disabledAt: Maybe<Scalars['DateTime']['output']>;
  disabledBy: Maybe<Scalars['String']['output']>;
  groupOrder: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  lastUnpublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastUnpublishedBy: Maybe<Scalars['String']['output']>;
  learningObjectiveStatement: Maybe<LearningObjectiveStatement>;
  metadata: QuestionMetadata;
  pInitial: Maybe<Scalars['Float']['output']>;
  pType: Maybe<QuestionPType>;
  pValue: Maybe<Scalars['Float']['output']>;
  questionGroup: Maybe<QuestionGroup>;
  questionGroupId: Scalars['String']['output'];
  questionStructures: Maybe<Array<QuestionStructure>>;
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  refQuestion: Maybe<Question>;
  refQuestionId: Maybe<Scalars['String']['output']>;
  solution: Maybe<QuestionSolution>;
  status: QuestionStatus;
  tagIds: Maybe<Array<Scalars['String']['output']>>;
  tags: Array<Tag>;
  taskComments: Array<QuestionComment>;
  taskVerdicts: Array<QuestionVerdict>;
  type: QuestionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionChoice = {
  __typename?: 'QuestionChoice';
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type QuestionChoiceInput = {
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuestionComment = {
  __typename?: 'QuestionComment';
  content: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  entityType: CommentEntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type QuestionCorrectAnswer = {
  __typename?: 'QuestionCorrectAnswer';
  value: Scalars['String']['output'];
};

export type QuestionCorrectAnswerInput = {
  value: Scalars['String']['input'];
};

export enum QuestionCreationTaskContentType {
  Gif = 'gif',
  Jpeg = 'jpeg',
  Png = 'png',
  Webp = 'webp'
}

export type QuestionDetailsResult = {
  __typename?: 'QuestionDetailsResult';
  groupOrder: Scalars['Int']['output'];
  metadata: Scalars['JSON']['output'];
  order: Scalars['Int']['output'];
  pValue: Scalars['Float']['output'];
  questionGroupId: Scalars['String']['output'];
  questionGroupType: QSetQuestionGroupType;
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type QuestionFileInput = {
  fileNames: Array<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

export type QuestionGroup = {
  __typename?: 'QuestionGroup';
  disabledAt: Maybe<Scalars['DateTime']['output']>;
  disabledBy: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  lastUnpublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastUnpublishedBy: Maybe<Scalars['String']['output']>;
  metadata: Maybe<QuestionGroupMetadata>;
  name: Scalars['String']['output'];
  questionStructures: Array<QuestionStructure>;
  questions: Maybe<Array<Question>>;
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  size: Maybe<Scalars['Int']['output']>;
  status: QuestionGroupStatus;
  totalQuestions: Scalars['Float']['output'];
  type: QuestionGroupType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionGroupFileInput = {
  fileNames: Array<Scalars['String']['input']>;
  questionGroupId: Scalars['String']['input'];
};

export type QuestionGroupMetadata = {
  __typename?: 'QuestionGroupMetadata';
  paragraph: Maybe<Scalars['String']['output']>;
};

export enum QuestionGroupStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  InDevelopment = 'IN_DEVELOPMENT',
  InReview = 'IN_REVIEW',
  Na = 'NA',
  PreDraft = 'PRE_DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum QuestionGroupType {
  ItemSet = 'ITEM_SET',
  LotOfQuestion = 'LOT_OF_QUESTION',
  Single = 'SINGLE'
}

export type QuestionGroupsResult = {
  __typename?: 'QuestionGroupsResult';
  questionGroups: Array<QuestionGroup>;
  total: Scalars['Float']['output'];
};

export enum QuestionImportType {
  ItemSet = 'ITEM_SET',
  SingleAndLoq = 'SINGLE_AND_LOQ'
}

export type QuestionInputData = {
  audit1?: InputMaybe<Scalars['String']['input']>;
  audit2?: InputMaybe<Scalars['String']['input']>;
  audit3?: InputMaybe<Scalars['String']['input']>;
  bIndexValue?: InputMaybe<Scalars['Float']['input']>;
  calculated?: InputMaybe<Scalars['Boolean']['input']>;
  choices: Array<QuestionChoiceInput>;
  cognitiveDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  correctAnswer: QuestionCorrectAnswerInput;
  details: Scalars['String']['input'];
  group: QuestionInputGroup;
  learningObjectiveStatement?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pInitial?: InputMaybe<Scalars['Float']['input']>;
  pStats?: InputMaybe<Array<QuestionPStatInputData>>;
  pType?: InputMaybe<QuestionPType>;
  pValue?: InputMaybe<Scalars['Float']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionInputGroup = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: QuestionGroupType;
};

export type QuestionKeywordSearchItemDto = {
  __typename?: 'QuestionKeywordSearchItemDTO';
  bIndexValue: Maybe<Scalars['Float']['output']>;
  correctAnswer: QuestionSearchCorrectAnswerDto;
  createdBy: Scalars['String']['output'];
  details: Scalars['String']['output'];
  groupOrder: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['String']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  locationIds: Array<Scalars['String']['output']>;
  metadata: QuestionSearchMetadataDto;
  pValue: Maybe<Scalars['Float']['output']>;
  questionGroup: Maybe<QuestionSearchGroupDto>;
  questionGroupId: Scalars['String']['output'];
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  solution: Maybe<QuestionSearchSolutionDto>;
  status: Scalars['String']['output'];
  tags: Array<QuestionSearchTagDto>;
  type: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
};

export type QuestionKeywordSearchResultDto = {
  __typename?: 'QuestionKeywordSearchResultDTO';
  items: Array<QuestionKeywordSearchItemDto>;
  total: Scalars['Int']['output'];
};

export type QuestionMetadata = {
  __typename?: 'QuestionMetadata';
  audit1: Maybe<Scalars['String']['output']>;
  audit2: Maybe<Scalars['String']['output']>;
  audit3: Maybe<Scalars['String']['output']>;
  choices: Array<QuestionChoice>;
  owner: Maybe<QuestionOwner>;
  pStats: Maybe<Array<QuestionPStats>>;
  reference: Maybe<Scalars['String']['output']>;
};

export type QuestionOwner = {
  __typename?: 'QuestionOwner';
  type: QuestionOwnerType;
  value: Maybe<Scalars['String']['output']>;
};

export enum QuestionOwnerType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type QuestionPStatInputData = {
  calculatedAt: Scalars['DateTime']['input'];
  firstUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pValue: Scalars['Float']['input'];
  sampleSize: Scalars['Float']['input'];
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy: Scalars['String']['input'];
  updatedUserFullName: Scalars['String']['input'];
};

export type QuestionPStats = {
  __typename?: 'QuestionPStats';
  calculatedAt: Scalars['DateTime']['output'];
  firstUsedAt: Maybe<Scalars['DateTime']['output']>;
  pValue: Scalars['Float']['output'];
  sampleSize: Scalars['Float']['output'];
  selected: Maybe<Scalars['Boolean']['output']>;
  updatedBy: Scalars['String']['output'];
  updatedUserFullName: Scalars['String']['output'];
};

export enum QuestionPType {
  PInitial = 'P_INITIAL',
  PStat = 'P_STAT'
}

export type QuestionSearchChoiceDto = {
  __typename?: 'QuestionSearchChoiceDTO';
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type QuestionSearchCorrectAnswerDto = {
  __typename?: 'QuestionSearchCorrectAnswerDTO';
  value: Maybe<Scalars['String']['output']>;
};

export enum QuestionSearchField {
  Choices = 'CHOICES',
  Paragraph = 'PARAGRAPH',
  Question = 'QUESTION',
  Reference = 'REFERENCE',
  Solution = 'SOLUTION'
}

export type QuestionSearchGroupDto = {
  __typename?: 'QuestionSearchGroupDTO';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paragraph: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type QuestionSearchMetadataDto = {
  __typename?: 'QuestionSearchMetadataDTO';
  audit1: Maybe<Scalars['String']['output']>;
  audit2: Maybe<Scalars['String']['output']>;
  audit3: Maybe<Scalars['String']['output']>;
  choices: Array<QuestionSearchChoiceDto>;
  firstPublishedAt: Maybe<Scalars['String']['output']>;
  owner: Maybe<QuestionSearchOwnerDto>;
  reference: Maybe<Scalars['String']['output']>;
};

export type QuestionSearchOwnerDto = {
  __typename?: 'QuestionSearchOwnerDTO';
  type: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type QuestionSearchSolutionDto = {
  __typename?: 'QuestionSearchSolutionDTO';
  type: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type QuestionSearchTagDto = {
  __typename?: 'QuestionSearchTagDTO';
  category: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type QuestionSnapshotCorrectAnswer = {
  __typename?: 'QuestionSnapshotCorrectAnswer';
  value: Scalars['String']['output'];
};

export type QuestionSnapshotStructure = {
  __typename?: 'QuestionSnapshotStructure';
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  refLevelItemId: Scalars['String']['output'];
  refSource: Scalars['String']['output'];
};

export type QuestionSolution = {
  __typename?: 'QuestionSolution';
  type: Maybe<QuestionSolutionType>;
  value: Maybe<Scalars['String']['output']>;
};

export enum QuestionSolutionType {
  Html = 'HTML'
}

export enum QuestionStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  InDevelopment = 'IN_DEVELOPMENT',
  InReview = 'IN_REVIEW',
  PreDraft = 'PRE_DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type QuestionStructure = {
  __typename?: 'QuestionStructure';
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  levelItem: Maybe<QBankStructureLevelItem>;
  refLevelItemId: Scalars['String']['output'];
  refSource: Scalars['String']['output'];
};

export type QuestionTag = {
  __typename?: 'QuestionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QuestionTagCategory {
  Calculation = 'CALCULATION',
  CognitiveDomain = 'COGNITIVE_DOMAIN',
  Difficulty = 'DIFFICULTY'
}

export enum QuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE'
}

export type QuestionVerdict = {
  __typename?: 'QuestionVerdict';
  entityId: Scalars['String']['output'];
  entityType: VerdictEntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  verdict: Verdict;
};

export type QuestionsResult = {
  __typename?: 'QuestionsResult';
  questions: Array<Question>;
  total: Scalars['Float']['output'];
};

export type QuickCreateInput = {
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QuickCreateUserObjectType = {
  __typename?: 'QuickCreateUserObjectType';
  appRolesResponse: AssignUserAppRolesMutationResponse;
  code: Scalars['String']['output'];
  createdUser: UserAppRoleView;
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RandomPreviewQuestionsByTaskIdInput = {
  options?: InputMaybe<RandomPreviewQuestionsByTaskIdInputOptions>;
  taskId: Scalars['String']['input'];
};

export type RandomPreviewQuestionsByTaskIdInputOptions = {
  isRandom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RandomPreviewQuestionsByTaskIdOutput = {
  __typename?: 'RandomPreviewQuestionsByTaskIdOutput';
  randomPreviewQuestionIds: Array<Scalars['String']['output']>;
};

export type RawUser = {
  __typename?: 'RawUser';
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Scalars['Boolean']['output'];
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type RemoveUsersContentVisibilityInput = {
  contentId: Scalars['String']['input'];
  contentType: ContentType;
  parentContentId?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['String']['input']>;
};

export type RemoveUsersContentVisibilityResult = {
  __typename?: 'RemoveUsersContentVisibilityResult';
  removedContentVisibilities: Array<ContentVisibility>;
  total: Scalars['Int']['output'];
};

export type ResendResetPasswordEmailOutputObjectType = {
  __typename?: 'ResendResetPasswordEmailOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResendResetPasswordUserLockedOutputObjectType = {
  __typename?: 'ResendResetPasswordUserLockedOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordOutputObjectType = {
  __typename?: 'ResetPasswordOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetUserTwoFactorInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ResetUserTwoFactorOutputObjectType = {
  __typename?: 'ResetUserTwoFactorOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: UserAppRoleView;
};

export type SetUser = {
  __typename?: 'SETUser';
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Scalars['Boolean']['output'];
  lastLoginAt: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SaveAsInput = {
  levelItems: Array<SaveAsLevelItemInput>;
  qBankStructureId: Scalars['String']['input'];
};

export type SaveAsLevelItemInput = {
  id: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  parentLevelItemId?: InputMaybe<Scalars['String']['input']>;
  qBankStructureLevelId: Scalars['String']['input'];
  tag?: InputMaybe<SaveAsTagInput>;
};

export type SaveAsTagInput = {
  name: Scalars['String']['input'];
};

export type SaveItemSetAsDraftInput = {
  groupOrders?: InputMaybe<Array<GroupOrderInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
  questionGroupId: Scalars['String']['input'];
};

export type SaveItemSetAsUnpublishInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
};

export type SaveQuestionAsDraftInput = {
  data: QuestionInputData;
  id: Scalars['String']['input'];
  qBankStructureLevelItemId: Scalars['String']['input'];
};

export type SaveQuestionAsUnpublishInput = {
  data: QuestionInputData;
  id: Scalars['String']['input'];
};

export type SearchExamCourseGroupsByNameInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SearchExamCourseGroupsByNameOutput = {
  __typename?: 'SearchExamCourseGroupsByNameOutput';
  tags: Array<Tag>;
};

export type SearchExamCoursesInput = {
  filter?: InputMaybe<SearchFilterInput>;
  groupTagId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCoursesOutput = {
  __typename?: 'SearchExamCoursesOutput';
  examCourses: Array<ExamCourse>;
  total: Scalars['Float']['output'];
};

export type SearchFilterInput = {
  conditions?: InputMaybe<Array<FilterConditionInput>>;
  searchText?: InputMaybe<SearchTextInput>;
};

export type SearchInput = {
  operator: OperatorType;
  value: Scalars['String']['input'];
};

export type SearchLearningObjectiveStatementsInput = {
  chapterLevelItemId?: InputMaybe<Scalars['String']['input']>;
  qBankStructureId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LearningObjectiveStatementStatus>;
};

export type SearchMyTasksFilterInput = {
  status: TaskStatus;
};

export type SearchMyTasksInput = {
  filter: SearchMyTasksFilterInput;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchMyTasksOutput = {
  __typename?: 'SearchMyTasksOutput';
  tasks: Array<Task>;
  total: Scalars['Float']['output'];
};

export type SearchOwnedAndAssignedTasksInput = {
  currentWorkflowStepCode?: InputMaybe<Array<WorkflowStepCode>>;
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
  workflowCode?: InputMaybe<WorkflowCode>;
};

export type SearchOwnedAndAssignedTasksOutput = {
  __typename?: 'SearchOwnedAndAssignedTasksOutput';
  tasks: Array<Task>;
  total: Scalars['Float']['output'];
};

export type SearchQBankStructureAuditLogOutput = {
  __typename?: 'SearchQBankStructureAuditLogOutput';
  qBankStructureAuditLogs: Array<QBankStructureAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchQBankStructureAuditLogsInputType = {
  filter?: InputMaybe<QBankStructureAuditLogSearchFilterInput>;
  jsonContainsFilter?: InputMaybe<JsonContainsFilterInput>;
  order?: InputMaybe<QBankStructureAuditLogOrderInput>;
  paging?: InputMaybe<QBankStructureAuditLogPagingInput>;
};

export type SearchQBankStructureGroupTagInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SearchQBankStructureInput = {
  groupTagId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<QBankStructureStatus>>;
  type?: InputMaybe<Array<QBankStructureType>>;
};

export type SearchQConfigAuditLogInput = {
  filter?: InputMaybe<SearchFilterInput>;
  jsonContainsFilter?: InputMaybe<JsonContainsFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQConfigAuditLogOutput = {
  __typename?: 'SearchQConfigAuditLogOutput';
  qConfigAuditLogs: Array<QConfigAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchQConfigGeneratorsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQConfigGeneratorsOutput = {
  __typename?: 'SearchQConfigGeneratorsOutput';
  qConfigGenerators: Array<QConfigGenerator>;
  total: Scalars['Int']['output'];
};

export type SearchQConfigsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQConfigsOutput = {
  __typename?: 'SearchQConfigsOutput';
  qConfigs: Array<QConfig>;
  total: Scalars['Float']['output'];
};

export type SearchQContentAuditLogOutput = {
  __typename?: 'SearchQContentAuditLogOutput';
  qContentAuditLogs: Array<QContentAuditLogObjectType>;
  total: Scalars['Float']['output'];
};

export type SearchQContentAuditLogsInputType = {
  filter?: InputMaybe<QContentAuditLogSearchFilterInput>;
  jsonContainsFilter?: InputMaybe<JsonContainsFilterInput>;
  order?: InputMaybe<QContentAuditLogOrderInput>;
  paging?: InputMaybe<QContentAuditLogPagingInput>;
};

export type SearchQSetAuditLogInput = {
  filter?: InputMaybe<SearchFilterInput>;
  jsonContainsFilter?: InputMaybe<JsonContainsFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQSetAuditLogOutput = {
  __typename?: 'SearchQSetAuditLogOutput';
  qSetAuditLogs: Array<QSetAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchQSetQuestionsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQSetQuestionsInputWithTaskIdInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
  qSetId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type SearchQSetQuestionsOutput = {
  __typename?: 'SearchQSetQuestionsOutput';
  qSetQuestions: Array<QSetQuestion>;
  total: Scalars['Float']['output'];
};

export type SearchQSetsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQSetsOutput = {
  __typename?: 'SearchQSetsOutput';
  qSets: Array<QSet>;
  total: Scalars['Int']['output'];
};

export type SearchQuestionGroupsInput = {
  levelItemId?: InputMaybe<Scalars['String']['input']>;
  questionGroupType?: InputMaybe<Array<QuestionGroupType>>;
  questionRefCode?: InputMaybe<Array<Scalars['String']['input']>>;
  refCode?: InputMaybe<Array<Scalars['String']['input']>>;
  refQBankStructureId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<QuestionGroupStatus>>;
};

export type SearchQuestionsByKeywordInput = {
  fields?: InputMaybe<Array<QuestionSearchField>>;
  keyword: Scalars['String']['input'];
  refQBankStructureIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<QuestionStatus>>;
};

export type SearchQuestionsByQIdsInput = {
  qIds: Array<Scalars['String']['input']>;
};

export type SearchQuestionsByQIdsResultDto = {
  __typename?: 'SearchQuestionsByQIdsResultDTO';
  /** Input QIDs that matched at least one question. */
  foundQIds: Array<Scalars['String']['output']>;
  items: Array<QuestionKeywordSearchItemDto>;
  /** Input QIDs with no matching question (render as red chips). */
  notFoundQIds: Array<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type SearchQuestionsInLearningObjectiveStatementInput = {
  learningObjectiveStatementId: Scalars['String']['input'];
};

export type SearchQuestionsInput = {
  levelItemId?: InputMaybe<Scalars['String']['input']>;
  questionGroupName?: InputMaybe<Scalars['String']['input']>;
  questionGroupType?: InputMaybe<Array<QuestionGroupType>>;
  refCode?: InputMaybe<Array<Scalars['String']['input']>>;
  refQBankStructureId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<QuestionStatus>>;
};

export type SearchTagsInput = {
  category?: InputMaybe<TagCategory>;
};

export type SearchTaskTagsInput = {
  category: QuestionTagCategory;
};

export type SearchTextInput = {
  /** Fields to search in */
  fields: Array<Scalars['String']['input']>;
  /** Search text */
  value: Scalars['String']['input'];
};

export type SearchUsersContentVisibilityInput = {
  contentId: Scalars['String']['input'];
  contentType: ContentType;
  isInvertUserFilter?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  parentContentId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withUserDetails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SingleQuestionProperties = {
  __typename?: 'SingleQuestionProperties';
  tags: Array<QuestionTag>;
  totalQuestions: Scalars['Int']['output'];
};

export type SingleQuestionPropertiesByLocation = {
  __typename?: 'SingleQuestionPropertiesByLocation';
  locationId: Scalars['String']['output'];
  locationType: SingleQuestionPropertiesLocationType;
  questionProperties: Array<SingleQuestionProperties>;
};

export enum SingleQuestionPropertiesLocationType {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export enum SingleQuestionPropertiesStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type SingleQuestionQuestionGroupProperties = {
  __typename?: 'SingleQuestionQuestionGroupProperties';
  questionGroupType: QuestionGroupType;
  questionProperties: Array<SingleQuestionProperties>;
  totalQuestionGroups: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type SingleQuestionQuestionGroupPropertiesByLocation = {
  __typename?: 'SingleQuestionQuestionGroupPropertiesByLocation';
  locationId: Scalars['String']['output'];
  locationType: SingleQuestionPropertiesLocationType;
  questionGroupProperties: Array<SingleQuestionQuestionGroupProperties>;
};

export type StepTransition = {
  __typename?: 'StepTransition';
  appPermissionIds: Maybe<Array<Scalars['String']['output']>>;
  condition: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type StorageObject = {
  __typename?: 'StorageObject';
  bucket: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  provider: StorageProvider;
};

export enum StorageProvider {
  GcloudStorage = 'GCLOUD_STORAGE'
}

export type StructureCriteriaInput = {
  passingCriteria?: InputMaybe<PassingCriteriaInput>;
  structureId: Scalars['String']['input'];
};

export enum SubmitQSetReviewErrorCode {
  MissingVerdict = 'MISSING_VERDICT',
  TaskOverdue = 'TASK_OVERDUE'
}

export type SubmitQSetReviewInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  taskId: Scalars['String']['input'];
};

export type SubmitQSetReviewOutput = {
  __typename?: 'SubmitQSetReviewOutput';
  code: Maybe<SubmitQSetReviewErrorCode>;
  message: Scalars['String']['output'];
  missingQuestionVerdictCount: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  task: Task;
};

export enum SubmitQuestionReviewErrorCode {
  MissingVerdict = 'MISSING_VERDICT',
  TaskOverdue = 'TASK_OVERDUE'
}

export type SubmitQuestionReviewInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  taskId: Scalars['String']['input'];
};

export type SubmitQuestionReviewOutput = {
  __typename?: 'SubmitQuestionReviewOutput';
  code: Maybe<SubmitQuestionReviewErrorCode>;
  message: Scalars['String']['output'];
  missingQuestionVerdictCount: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  task: Task;
};

export type Tag = {
  __typename?: 'Tag';
  category: TagCategory;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
};

export enum TagCategory {
  Calculation = 'CALCULATION',
  CognitiveDomain = 'COGNITIVE_DOMAIN',
  Difficulty = 'DIFFICULTY',
  ExamCourseGroup = 'EXAM_COURSE_GROUP',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureGroup = 'QBANK_STRUCTURE_GROUP',
  QbankStructureLevel = 'QBANK_STRUCTURE_LEVEL'
}

export type TagEntity = {
  __typename?: 'TagEntity';
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  tag: Tag;
  tagId: Scalars['String']['output'];
};

export type TagGroup = {
  __typename?: 'TagGroup';
  count: Scalars['Int']['output'];
  tags: Array<QuestionTag>;
};

export type TagResult = {
  __typename?: 'TagResult';
  tags: Array<Tag>;
  total: Scalars['Int']['output'];
};

export type Task = {
  __typename?: 'Task';
  actorId: Maybe<Scalars['String']['output']>;
  assignedAt: Scalars['DateTime']['output'];
  assignee: RawUser;
  assigneeId: Scalars['String']['output'];
  assigner: RawUser;
  assignerId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentWorkflowStep: WorkflowStep;
  currentWorkflowStepId: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  metadata: TaskMetadata;
  name: Maybe<Scalars['String']['output']>;
  owner: RawUser;
  ownerId: Scalars['String']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  parentTask: Maybe<Task>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: TaskStatus;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  subtaskCount: Scalars['Float']['output'];
  subtasks: Array<Task>;
  taskEntities: Array<TaskEntity>;
  updatedAt: Scalars['DateTime']['output'];
  workflowId: Scalars['String']['output'];
};

export type TaskComment = {
  __typename?: 'TaskComment';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: RawUser;
  userId: Scalars['String']['output'];
};

export type TaskDetailsForItemSetCreationInput = {
  targetSize: Scalars['Float']['input'];
  taskId: Scalars['String']['input'];
};

export type TaskEntity = {
  __typename?: 'TaskEntity';
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
};

export type TaskMetadata = TaskMetadataWithAdditionalData | TaskMetadataWithExamCourse | TaskMetadataWithQSet | TaskMetadataWithQuestionCreation | TaskMetadataWithQuestionReviewed | TaskMetadataWithReviewQuestion;

export type TaskMetadataWithAdditionalData = {
  __typename?: 'TaskMetadataWithAdditionalData';
  additionalData: Scalars['JSON']['output'];
};

export type TaskMetadataWithExamCourse = {
  __typename?: 'TaskMetadataWithExamCourse';
  examCourse: ExamCourseTask;
  subtaskEntityQuantity: Scalars['Float']['output'];
};

export type TaskMetadataWithQSet = {
  __typename?: 'TaskMetadataWithQSet';
  qSet: QSetTask;
};

export type TaskMetadataWithQuestionCreation = {
  __typename?: 'TaskMetadataWithQuestionCreation';
  details: Maybe<Scalars['String']['output']>;
  itemSetCondition: Maybe<Array<ItemSetCondition>>;
  itemSetCreation: Maybe<Array<ItemSetCreation>>;
  qBankStructure: Maybe<QBankStructureTask>;
  questionCreationCount: Scalars['Float']['output'];
  requiredQuestionCount: Maybe<Scalars['Float']['output']>;
};

export type TaskMetadataWithQuestionReviewed = {
  __typename?: 'TaskMetadataWithQuestionReviewed';
  reviewedQuestionCount: Scalars['Int']['output'];
};

export type TaskMetadataWithReviewQuestion = {
  __typename?: 'TaskMetadataWithReviewQuestion';
  qBankStructure: Maybe<QBankStructureTask>;
  questionQuantity: Scalars['Int']['output'];
  subtaskEntityQuantity: Scalars['Float']['output'];
};

export type TaskQConfigConditionTag = {
  __typename?: 'TaskQConfigConditionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum TaskStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

export type TaskWithSubtasks = {
  __typename?: 'TaskWithSubtasks';
  actorId: Maybe<Scalars['String']['output']>;
  assignedAt: Scalars['DateTime']['output'];
  assignee: RawUser;
  assigneeId: Scalars['String']['output'];
  assigner: RawUser;
  assignerId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentWorkflowStep: WorkflowStep;
  currentWorkflowStepId: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata: TaskMetadata;
  name: Maybe<Scalars['String']['output']>;
  owner: RawUser;
  ownerId: Scalars['String']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: TaskStatus;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  subtasks: Array<TaskWithSubtasks>;
  updatedAt: Scalars['DateTime']['output'];
  workflowId: Scalars['String']['output'];
};

export type TimeLimitInput = {
  type: QConfigTimeLimitType;
  values: Array<TimeLimitValueInput>;
};

export type TimeLimitValueInput = {
  order: Scalars['Int']['input'];
  qConfigStructureIds?: InputMaybe<Array<Scalars['String']['input']>>;
  value: Scalars['Int']['input'];
};

export type TokenStatus = {
  __typename?: 'TokenStatus';
  email: Maybe<Scalars['String']['output']>;
  scopes: Maybe<Array<Scalars['String']['output']>>;
  ttl: Maybe<Scalars['Float']['output']>;
  twoFactorStatus: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type UnassignUserAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UnassignUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UnassignUserAppRolesMutationResponse = {
  __typename?: 'UnassignUserAppRolesMutationResponse';
  appRoles: Array<AppRole>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnlockUserTwoFactorInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UnlockUserTwoFactorOutputObjectType = {
  __typename?: 'UnlockUserTwoFactorOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: UserAppRoleView;
};

export type UpdateAndCreateSubtasks = {
  assigneeId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EntityType>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAndCreateSubtasksInput = {
  mainTaskId: Scalars['String']['input'];
  subtasks: Array<UpdateAndCreateSubtasks>;
  workflowCode: WorkflowCode;
};

export type UpdateAndCreateSubtasksOutput = {
  __typename?: 'UpdateAndCreateSubtasksOutput';
  subtasks: Array<Task>;
};

export type UpdateAppRoleAppPermissionsMutationResponse = {
  __typename?: 'UpdateAppRoleAppPermissionsMutationResponse';
  appPermission: Array<AppPermission>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateAppRoleMutationResponse = {
  __typename?: 'UpdateAppRoleMutationResponse';
  appRole: AppRole;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateContentVisibilityInputObject = {
  contentId: Scalars['String']['input'];
  contentType: ContentType;
  parentContentId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentVisibilityObject = {
  __typename?: 'UpdateContentVisibilityObject';
  contentId: Scalars['String']['output'];
  contentType: ContentType;
  parentContentId: Maybe<Scalars['String']['output']>;
};

export type UpdateDueDateTaskAndSubtasksInput = {
  dueDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
};

export type UpdateExamUsageOfQSetsInput = {
  qSetIds: Array<Scalars['String']['input']>;
  toExamUsageStatus: ExamUsageStatus;
};

export type UpdateExamUsageOfQSetsOutput = {
  __typename?: 'UpdateExamUsageOfQSetsOutput';
  qSets: Array<QSet>;
};

export type UpdateItemSetQuestionQConfigStructureConditionInput = {
  needTotal: Scalars['Int']['input'];
  tagGroups: Array<UpdateItemSetQuestionQConfigStructureConditionTagGroupInput>;
};

export type UpdateItemSetQuestionQConfigStructureConditionTagGroupInput = {
  count: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};

export type UpdateItemSetQuestionQConfigStructureInput = {
  conditions: Array<UpdateItemSetQuestionQConfigStructureConditionInput>;
  id: Scalars['String']['input'];
  location: UpdateItemSetQuestionQConfigStructureLocationInput;
  scorePerQuestion: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type UpdateItemSetQuestionQConfigStructureLocationInput = {
  locationType: UpdateQuestionQConfigStructureLocationTypeInput;
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateItemSetQuestionQConfigStructureOutput = {
  __typename?: 'UpdateItemSetQuestionQConfigStructureOutput';
  qConfig: QConfig;
};

export type UpdateLearningObjectiveStatementInput = {
  chapterLevelItemId: Scalars['String']['input'];
  learningObjectiveStatementId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
};

export type UpdateOrCreateExamCourseVerdictInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  taskId: Scalars['String']['input'];
  verdict: Verdict;
};

export type UpdateOrCreateExamCourseVerdictOutput = {
  __typename?: 'UpdateOrCreateExamCourseVerdictOutput';
  verdict: ExamCourseVerdictOutput;
};

export type UpdateQBankStructureAsArchivedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQBankStructureAsDraftInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QBankStructureType>;
};

export type UpdateQBankStructureAsPublishedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQBankStructureAsUnpublishedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQBankStructureLevelInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type UpdateQBankStructureLevelsByQBankStructureIdInput = {
  qBankStructureId: Scalars['String']['input'];
  qBankStructureLevels: Array<UpdateQBankStructureLevelInput>;
};

export type UpdateQConfigAsDraftInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  qConfigId: Scalars['String']['input'];
  totalQuestions?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateQConfigAsDraftOutput = {
  __typename?: 'UpdateQConfigAsDraftOutput';
  qConfig: QConfig;
};

export type UpdateQConfigSettingsAsDraftInput = {
  passingCriteria?: InputMaybe<PassingCriteriaInput>;
  qConfigId: Scalars['String']['input'];
  randomType?: InputMaybe<QConfigRandomType>;
  structurePassingCriteria?: InputMaybe<Array<StructureCriteriaInput>>;
  timeLimit?: InputMaybe<TimeLimitInput>;
};

export type UpdateQConfigSettingsAsDraftOutput = {
  __typename?: 'UpdateQConfigSettingsAsDraftOutput';
  qConfig: QConfig;
};

export type UpdateQConfigStructureNamesInput = {
  qConfigId: Scalars['String']['input'];
  structures: Array<QConfigStructureNameInput>;
};

export type UpdateQConfigStructureNamesOutput = {
  __typename?: 'UpdateQConfigStructureNamesOutput';
  qConfigStructures: Array<QConfigStructure>;
};

export type UpdateQuestionCreationTaskInput = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type UpdateQuestionCreationTaskOutputDto = {
  __typename?: 'UpdateQuestionCreationTaskOutputDTO';
  task: Task;
};

export enum UpdateQuestionQConfigStructureLocationTypeInput {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export type UpdateSingleQuestionQConfigStructureConditionInput = {
  needTotal: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};

export type UpdateSingleQuestionQConfigStructureInput = {
  conditions: Array<UpdateSingleQuestionQConfigStructureConditionInput>;
  id: Scalars['String']['input'];
  location: UpdateSingleQuestionQConfigStructureLocationInput;
  scorePerQuestion: Scalars['Int']['input'];
};

export type UpdateSingleQuestionQConfigStructureLocationInput = {
  locationType: UpdateQuestionQConfigStructureLocationTypeInput;
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSingleQuestionQConfigStructureOutput = {
  __typename?: 'UpdateSingleQuestionQConfigStructureOutput';
  qConfig: QConfig;
};

export type UpdateSubtaskInput = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  id: Scalars['String']['input'];
};

export type UpdateSubtasksAndCreateSubtasks = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubtasksInput = {
  mainTaskId: Scalars['String']['input'];
  subtasks: Array<UpdateSubtaskInput>;
};

export type UpdateSubtasksOutput = {
  __typename?: 'UpdateSubtasksOutput';
  tasks: Array<Task>;
};

export type UpdateTaskAndSubtasksAndCreateSubtasksInput = {
  mainTaskId: Scalars['String']['input'];
  subtasks: Array<UpdateSubtasksAndCreateSubtasks>;
  taskAssigneeId: Scalars['String']['input'];
  taskDueDate: Scalars['DateTime']['input'];
  taskName: Scalars['String']['input'];
  workflowCode: WorkflowCode;
};

export type UpdateTaskAndSubtasksAndCreateSubtasksOutput = {
  __typename?: 'UpdateTaskAndSubtasksAndCreateSubtasksOutput';
  subtasks: Array<Task>;
  task: Task;
};

export type UpdateTaskInput = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTaskOutputObjectType = {
  __typename?: 'UpdateTaskOutputObjectType';
  task: Task;
};

export type UpdateTaskStatusAuditorsInput = {
  audit1?: InputMaybe<Scalars['String']['input']>;
  audit2?: InputMaybe<Scalars['String']['input']>;
  audit3?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskStatusInput = {
  metadata?: InputMaybe<UpdateTaskStatusMetadataInput>;
  taskId: Scalars['String']['input'];
  workflowStepId: Scalars['String']['input'];
};

export type UpdateTaskStatusMetadataInput = {
  questions?: InputMaybe<Array<UpdateTaskStatusQuestionInput>>;
};

export type UpdateTaskStatusOutput = {
  __typename?: 'UpdateTaskStatusOutput';
  task: Task;
};

export type UpdateTaskStatusQuestionInput = {
  auditors?: InputMaybe<UpdateTaskStatusAuditorsInput>;
  id: Scalars['String']['input'];
  status: QuestionStatus;
};

export type UpdateUserAppRoleByNameMutationResponse = {
  __typename?: 'UpdateUserAppRoleByNameMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserAppRoleByNamesInput = {
  appRoleNames: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAppRolesMutationResponse = {
  __typename?: 'UpdateUserAppRolesMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  appRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  organizationInfo?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserOutputObjectType = {
  __typename?: 'UpdateUserOutputObjectType';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UpdateUserStatusInput = {
  status: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserStatusOutputObjectType = {
  __typename?: 'UpdateUserStatusOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedUser: UserAppRoleView;
};

export type UpdateUsersContentVisibilityInput = {
  courseId: Scalars['String']['input'];
  qbankStructureId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
  visibleContent: Array<UpdateContentVisibilityInputObject>;
};

export type UpdateUsersContentVisibilityResult = {
  __typename?: 'UpdateUsersContentVisibilityResult';
  courseId: Scalars['String']['output'];
  qbankStructureId: Scalars['String']['output'];
  userIds: Array<Scalars['String']['output']>;
  visibleContent: Array<UpdateContentVisibilityObject>;
};

export type UsBoGetTokenStatusResponse = {
  __typename?: 'UsBoGetTokenStatusResponse';
  result: TokenStatus;
};

export type UsBoUser = {
  __typename?: 'UsBoUser';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Maybe<Scalars['Boolean']['output']>;
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  newEmail: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['String']['output']>;
  organizationInfo: Maybe<Scalars['JSON']['output']>;
  realm: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamIds: Array<Scalars['String']['output']>;
  twoFactorStatus: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UsBoUserExcludeFieldsInput = {
  additional1?: InputMaybe<Array<Scalars['String']['input']>>;
  additional2?: InputMaybe<Array<Scalars['String']['input']>>;
  additional3?: InputMaybe<Array<Scalars['String']['input']>>;
  additional4?: InputMaybe<Array<Scalars['String']['input']>>;
  additional5?: InputMaybe<Array<Scalars['String']['input']>>;
  additional6?: InputMaybe<Array<Scalars['String']['input']>>;
  additional7?: InputMaybe<Array<Scalars['String']['input']>>;
  additional8?: InputMaybe<Array<Scalars['String']['input']>>;
  additional9?: InputMaybe<Array<Scalars['String']['input']>>;
  additional10?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstname?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  lastname?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UsBoUserSearchInput = {
  additional1?: InputMaybe<Scalars['String']['input']>;
  additional2?: InputMaybe<Scalars['String']['input']>;
  additional3?: InputMaybe<Scalars['String']['input']>;
  additional4?: InputMaybe<Scalars['String']['input']>;
  additional5?: InputMaybe<Scalars['String']['input']>;
  additional6?: InputMaybe<Scalars['String']['input']>;
  additional7?: InputMaybe<Scalars['String']['input']>;
  additional8?: InputMaybe<Scalars['String']['input']>;
  additional9?: InputMaybe<Scalars['String']['input']>;
  additional10?: InputMaybe<Scalars['String']['input']>;
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsBoUserSearchResult = {
  __typename?: 'UsBoUserSearchResult';
  total: Scalars['Int']['output'];
  users: Array<UsBoUser>;
};

export type UsUser = {
  __typename?: 'UsUser';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['DateTime']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  isAdmin: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Maybe<Scalars['Boolean']['output']>;
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  newEmail: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['String']['output']>;
  organizationInfo: Maybe<Scalars['JSON']['output']>;
  realm: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamIds: Array<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserAppRoleView = {
  __typename?: 'UserAppRoleView';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UserAppRoleViewSearchResult = {
  __typename?: 'UserAppRoleViewSearchResult';
  total: Scalars['Int']['output'];
  users: Array<UserAppRoleView>;
};

export type UserLoginInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum UserType {
  ClientUser = 'CLIENT_USER',
  UserApi = 'USER_API'
}

export type UsersContentVisibilityResult = {
  __typename?: 'UsersContentVisibilityResult';
  contentId: Scalars['String']['output'];
  contentType: ContentType;
  parentContentId: Maybe<Scalars['String']['output']>;
  userIds: Array<Scalars['String']['output']>;
};

export type UsersDataContentVisibilityResult = {
  __typename?: 'UsersDataContentVisibilityResult';
  contentId: Scalars['String']['output'];
  contentType: ContentType;
  parentContentId: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  users: Array<SetUser>;
};

export type ValidateIssue = {
  __typename?: 'ValidateIssue';
  details: Maybe<Scalars['String']['output']>;
  levelItemId: Maybe<Scalars['String']['output']>;
};

export type ValidateQBankStructureBeforePublishInput = {
  id: Scalars['String']['input'];
  levelItems: Array<SaveAsLevelItemInput>;
};

export type ValidateQBankStructureResult = {
  __typename?: 'ValidateQBankStructureResult';
  case: QBankStructureValidationCase;
  issues: Array<ValidateIssue>;
  passed: Scalars['Boolean']['output'];
};

export type ValidateTokenResult = {
  __typename?: 'ValidateTokenResult';
  description: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
};

/** The verdict of the content. */
export enum Verdict {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  NeedsRework = 'NEEDS_REWORK',
  Rejected = 'REJECTED'
}

export enum VerdictEntityType {
  ExaminationCourse = 'EXAMINATION_COURSE',
  Other = 'OTHER',
  Qconfig = 'QCONFIG',
  Qset = 'QSET',
  Question = 'QUESTION'
}

export type VerifyUserTwoFactorInput = {
  code: Scalars['String']['input'];
};

export type VerifyUserTwoFactorOutputObjectType = {
  __typename?: 'VerifyUserTwoFactorOutputObjectType';
  code: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum WorkflowCode {
  ExamLocationRequest = 'EXAM_LOCATION_REQUEST',
  ProctorRequest = 'PROCTOR_REQUEST',
  QuestionCreation = 'QUESTION_CREATION',
  QuestionReview = 'QUESTION_REVIEW',
  ReviewQSet = 'REVIEW_Q_SET'
}

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  code: WorkflowStepCode;
  consequences: Maybe<Scalars['JSON']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isTerminal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: TaskStatus;
  stepTransitions: Array<StepTransition>;
  workflowCode: WorkflowCode;
};

export enum WorkflowStepCode {
  ExamLocationRequestApproved = 'EXAM_LOCATION_REQUEST_APPROVED',
  ExamLocationRequestInReview_1 = 'EXAM_LOCATION_REQUEST_IN_REVIEW_1',
  ExamLocationRequestInReview_2 = 'EXAM_LOCATION_REQUEST_IN_REVIEW_2',
  ExamLocationRequestRejected = 'EXAM_LOCATION_REQUEST_REJECTED',
  ProctorRequestApproved = 'PROCTOR_REQUEST_APPROVED',
  ProctorRequestInReview_1 = 'PROCTOR_REQUEST_IN_REVIEW_1',
  ProctorRequestInReview_2 = 'PROCTOR_REQUEST_IN_REVIEW_2',
  ProctorRequestRejected = 'PROCTOR_REQUEST_REJECTED',
  QuestionCreationDone = 'QUESTION_CREATION_DONE',
  QuestionCreationInProgress = 'QUESTION_CREATION_IN_PROGRESS',
  QuestionCreationTodo = 'QUESTION_CREATION_TODO',
  QuestionReviewDone = 'QUESTION_REVIEW_DONE',
  QuestionReviewInReview = 'QUESTION_REVIEW_IN_REVIEW',
  QuestionReviewReviewed = 'QUESTION_REVIEW_REVIEWED',
  QuestionReviewTodo = 'QUESTION_REVIEW_TODO',
  ReviewQsetDone = 'REVIEW_QSET_DONE',
  ReviewQsetInReview = 'REVIEW_QSET_IN_REVIEW',
  ReviewQsetReviewed = 'REVIEW_QSET_REVIEWED',
  ReviewQsetTodo = 'REVIEW_QSET_TODO'
}

export type GetQSetQuestionsByTaskIdQueryVariables = Exact<{
  input: GetQSetQuestionsByTaskIdInput;
}>;


export type GetQSetQuestionsByTaskIdQuery = { __typename?: 'Query', excGetQSetQuestionsByTaskId: { __typename?: 'GetQSetQuestionsByTaskIdOutput', qSetQuestions: Array<{ __typename?: 'QSetQuestion', id: string, qSetId: string, questionId: string, questionGroupId: string, questionRefCode: string, order: number, score: number, metadata: { __typename?: 'QSetQuestionMetadata', qConfigStructures: Array<{ __typename?: 'QSetQuestionQConfigStructure', id: string, name: string | null, type: string, category: string | null }> }, question: { __typename?: 'Question', id: string, type: QuestionType, details: string, refCode: string, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, metadata: { __typename?: 'QuestionMetadata', reference: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }> }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, questionGroup: { __typename?: 'QuestionGroup', type: QuestionGroupType, size: number | null, refCode: string, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', tag: { __typename?: 'Tag', name: string, id: string } } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null } | null }> } };

export type GetQSetByTaskIdQueryVariables = Exact<{
  input: GetQSetByTaskIdInput;
}>;


export type GetQSetByTaskIdQuery = { __typename?: 'Query', excGetQSetByTaskId: { __typename?: 'GetQSetByTaskIdOutput', qSet: { __typename?: 'QSet', id: string, code: string, examCourseId: string, qConfigId: string, metadata: { __typename?: 'QSetMetadata', randomType: QConfigRandomType | null, qConfigStructureParts: Array<{ __typename?: 'QConfigStructureSnapShot', id: string, name: string | null, type: QConfigStructureType, category: QConfigStructureCategory | null, order: number, totalQuestions: number, score: number }> | null, qConfigStructures: Array<{ __typename?: 'QConfigStructureSnapShot', id: string, name: string | null, type: QConfigStructureType, category: QConfigStructureCategory | null, order: number, totalQuestions: number, score: number }> | null, passingCriteria: { __typename?: 'QSetPassingCriteria', byStructure: Array<{ __typename?: 'QSetPassingCriteriaByStructure', qConfigStructureId: string, value: number }> } | null } | null, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number, type: QConfigType, status: QConfigStatus, totalQuestions: number, fullScore: number, examCourseId: string, updatedAt: Date, metadata: { __typename?: 'QConfigMetadata', passingCriteria: { __typename?: 'QConfigPassingCriteria', type: QConfigPassingCriteriaType, value: number } | null, timeLimit: { __typename?: 'QConfigTimeLimit', type: QConfigTimeLimitType, total: number | null, values: Array<{ __typename?: 'QConfigTimeLimitValue', qConfigStructureIds: Array<string> | null, value: number, order: number }> } | null }, examCourse: { __typename?: 'ExamCourse', id: string, name: string }, structures: Array<{ __typename?: 'QConfigStructure', id: string, name: string | null, type: QConfigStructureType, category: QConfigStructureCategory | null, size: number | null, parentId: string | null, totalQuestions: number, score: number, order: number, qConfigId: string }>, timeLimit: { __typename?: 'QConfigTimeLimit', type: QConfigTimeLimitType, total: number | null, values: Array<{ __typename?: 'QConfigTimeLimitValue', qConfigStructureIds: Array<string> | null, value: number, order: number }> } | null } } } };

export type GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables = Exact<{
  input: GetDownloadSignedUrlForQuestionsByQSetIdInput;
}>;


export type GetDownloadSignedUrlForQuestionsByQSetIdQuery = { __typename?: 'Query', excGetDownloadSignedUrlForQuestionsByQSetId: { __typename?: 'GetDownloadSignedUrlForQuestionsByQSetIdOutput', signedUrls: any } };

export type RandomPreviewQuestionsByTaskIdQueryVariables = Exact<{
  input: RandomPreviewQuestionsByTaskIdInput;
}>;


export type RandomPreviewQuestionsByTaskIdQuery = { __typename?: 'Query', excRandomPreviewQuestionsByTaskId: { __typename?: 'RandomPreviewQuestionsByTaskIdOutput', randomPreviewQuestionIds: Array<string> } };

export type SendExamCourseCommentMutationVariables = Exact<{
  createExamCourseCommentInput: CreateExamCourseCommentInput;
}>;


export type SendExamCourseCommentMutation = { __typename?: 'Mutation', excCreateExamCourseComment: { __typename?: 'CreateExamCourseCommentOutput', comment: { __typename?: 'ExamCourseCommentOutput', id: string, taskId: string, userId: string, entityId: string, entityType: EntityType, content: string, createdAt: Date, updatedAt: Date } } };

export type ExcUpdateOrCreateExamCourseVerdictMutationVariables = Exact<{
  updateOrCreateExamCourseVerdictInput: UpdateOrCreateExamCourseVerdictInput;
}>;


export type ExcUpdateOrCreateExamCourseVerdictMutation = { __typename?: 'Mutation', excUpdateOrCreateExamCourseVerdict: { __typename?: 'UpdateOrCreateExamCourseVerdictOutput', verdict: { __typename?: 'ExamCourseVerdictOutput', verdict: Verdict } } };

export type GetExamCourseCommentsQueryVariables = Exact<{
  getExamCourseCommentsInput: GetExamCourseCommentsInput;
}>;


export type GetExamCourseCommentsQuery = { __typename?: 'Query', excGetExamCourseComments: { __typename?: 'GetExamCourseCommentsOutput', taskId: string, entityId: string, entityType: EntityType, comments: Array<{ __typename?: 'ExamCourseCommentOutput', id: string, taskId: string, userId: string, entityId: string, entityType: EntityType, content: string, createdAt: Date, updatedAt: Date, user: { __typename?: 'RawUser', firstname: string, lastname: string, email: string, image: string | null } }> } };

export type ExcGetExamCourseVerdictQueryVariables = Exact<{
  getExamCourseVerdictInput: GetExamCourseVerdictInput;
}>;


export type ExcGetExamCourseVerdictQuery = { __typename?: 'Query', excGetExamCourseVerdict: { __typename?: 'GetExamCourseVerdictOutput', entityId: string, entityType: EntityType, taskId: string, verdict: { __typename?: 'ExamCourseVerdictOutput', id: string, taskId: string, userId: string, entityId: string, entityType: EntityType, verdict: Verdict, createdAt: Date, updatedAt: Date } } };

export type ExcGetUploadSignedUrlForExamCourseCommentQueryVariables = Exact<{
  getUploadSignedUrlForExamCourseCommentInput: GetUploadSignedUrlForExamCourseCommentInput;
}>;


export type ExcGetUploadSignedUrlForExamCourseCommentQuery = { __typename?: 'Query', excGetUploadSignedUrlForExamCourseComment: { __typename?: 'GetUploadSignedUrlForExamCourseCommentOutput', signedUrl: string, storageObject: { __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null } } };

export type ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables = Exact<{
  getDownloadSignedUrlForExamCourseCommentInput: GetDownloadSignedUrlForExamCourseCommentInput;
}>;


export type ExcGetDownloadSignedUrlForExamCourseCommentQuery = { __typename?: 'Query', excGetDownloadSignedUrlForExamCourseComment: { __typename?: 'GetDownloadSignedUrlForExamCourseCommentOutput', signedUrls: any } };

export type GetPreviewTaskReviewRolesQueryVariables = Exact<{
  getTaskByIdInput: GetTaskByIdInput;
}>;


export type GetPreviewTaskReviewRolesQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', id: string, assignerId: string, assignee: { __typename?: 'RawUser', id: string }, parentTask: { __typename?: 'Task', ownerId: string } | null, currentWorkflowStep: { __typename?: 'WorkflowStep', code: WorkflowStepCode } } } };


export const GetQSetQuestionsByTaskIdDocument = gql`
    query getQSetQuestionsByTaskId($input: GetQSetQuestionsByTaskIdInput!) {
  excGetQSetQuestionsByTaskId(input: $input) {
    qSetQuestions {
      id
      qSetId
      questionId
      questionGroupId
      questionRefCode
      order
      score
      metadata {
        qConfigStructures {
          id
          name
          type
          category
        }
      }
      question {
        id
        tags {
          id
          name
          category
        }
        type
        details
        refCode
        metadata {
          choices {
            label
            order
            value
          }
          reference
        }
        correctAnswer {
          value
        }
        questionGroup {
          type
          size
          metadata {
            paragraph
          }
          refCode
        }
        learningObjectiveStatement {
          tag {
            name
            id
          }
        }
        solution {
          type
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetQSetQuestionsByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQSetQuestionsByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetQuestionsByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetQuestionsByTaskIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQSetQuestionsByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQSetQuestionsByTaskIdQuery, GetQSetQuestionsByTaskIdQueryVariables> & ({ variables: GetQSetQuestionsByTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetQuestionsByTaskIdQuery, GetQSetQuestionsByTaskIdQueryVariables>(GetQSetQuestionsByTaskIdDocument, options);
      }
export function useGetQSetQuestionsByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetQuestionsByTaskIdQuery, GetQSetQuestionsByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetQuestionsByTaskIdQuery, GetQSetQuestionsByTaskIdQueryVariables>(GetQSetQuestionsByTaskIdDocument, options);
        }
export function useGetQSetQuestionsByTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetQuestionsByTaskIdQuery, GetQSetQuestionsByTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetQuestionsByTaskIdQuery, GetQSetQuestionsByTaskIdQueryVariables>(GetQSetQuestionsByTaskIdDocument, options);
        }
export type GetQSetQuestionsByTaskIdQueryHookResult = ReturnType<typeof useGetQSetQuestionsByTaskIdQuery>;
export type GetQSetQuestionsByTaskIdLazyQueryHookResult = ReturnType<typeof useGetQSetQuestionsByTaskIdLazyQuery>;
export type GetQSetQuestionsByTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQSetQuestionsByTaskIdSuspenseQuery>;
export type GetQSetQuestionsByTaskIdQueryResult = Apollo.QueryResult<GetQSetQuestionsByTaskIdQuery, GetQSetQuestionsByTaskIdQueryVariables>;
export const GetQSetByTaskIdDocument = gql`
    query getQSetByTaskId($input: GetQSetByTaskIdInput!) {
  excGetQSetByTaskId(input: $input) {
    qSet {
      id
      code
      examCourseId
      qConfigId
      metadata {
        randomType
        qConfigStructureParts {
          id
          name
          type
          category
          order
          totalQuestions
          score
        }
        qConfigStructures {
          id
          name
          type
          category
          order
          totalQuestions
          score
        }
        passingCriteria {
          byStructure {
            qConfigStructureId
            value
          }
        }
      }
      qConfig {
        id
        name
        code
        type
        status
        metadata {
          passingCriteria {
            type
            value
          }
          timeLimit {
            type
            values {
              qConfigStructureIds
              value
              order
            }
            total
          }
        }
        totalQuestions
        fullScore
        examCourseId
        examCourse {
          id
          name
        }
        updatedAt
        structures {
          id
          name
          type
          category
          size
          parentId
          totalQuestions
          score
          order
          qConfigId
        }
        timeLimit {
          type
          values {
            qConfigStructureIds
            value
            order
          }
          total
        }
      }
    }
  }
}
    `;

/**
 * __useGetQSetByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQSetByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetByTaskIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQSetByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables> & ({ variables: GetQSetByTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>(GetQSetByTaskIdDocument, options);
      }
export function useGetQSetByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>(GetQSetByTaskIdDocument, options);
        }
export function useGetQSetByTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>(GetQSetByTaskIdDocument, options);
        }
export type GetQSetByTaskIdQueryHookResult = ReturnType<typeof useGetQSetByTaskIdQuery>;
export type GetQSetByTaskIdLazyQueryHookResult = ReturnType<typeof useGetQSetByTaskIdLazyQuery>;
export type GetQSetByTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQSetByTaskIdSuspenseQuery>;
export type GetQSetByTaskIdQueryResult = Apollo.QueryResult<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>;
export const GetDownloadSignedUrlForQuestionsByQSetIdDocument = gql`
    query getDownloadSignedUrlForQuestionsByQSetId($input: GetDownloadSignedUrlForQuestionsByQSetIdInput!) {
  excGetDownloadSignedUrlForQuestionsByQSetId(input: $input) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForQuestionsByQSetIdQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForQuestionsByQSetIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForQuestionsByQSetIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForQuestionsByQSetIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForQuestionsByQSetIdQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables> & ({ variables: GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>(GetDownloadSignedUrlForQuestionsByQSetIdDocument, options);
      }
export function useGetDownloadSignedUrlForQuestionsByQSetIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>(GetDownloadSignedUrlForQuestionsByQSetIdDocument, options);
        }
export function useGetDownloadSignedUrlForQuestionsByQSetIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>(GetDownloadSignedUrlForQuestionsByQSetIdDocument, options);
        }
export type GetDownloadSignedUrlForQuestionsByQSetIdQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsByQSetIdQuery>;
export type GetDownloadSignedUrlForQuestionsByQSetIdLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsByQSetIdLazyQuery>;
export type GetDownloadSignedUrlForQuestionsByQSetIdSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsByQSetIdSuspenseQuery>;
export type GetDownloadSignedUrlForQuestionsByQSetIdQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>;
export const RandomPreviewQuestionsByTaskIdDocument = gql`
    query randomPreviewQuestionsByTaskId($input: RandomPreviewQuestionsByTaskIdInput!) {
  excRandomPreviewQuestionsByTaskId(input: $input) {
    randomPreviewQuestionIds
  }
}
    `;

/**
 * __useRandomPreviewQuestionsByTaskIdQuery__
 *
 * To run a query within a React component, call `useRandomPreviewQuestionsByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRandomPreviewQuestionsByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRandomPreviewQuestionsByTaskIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRandomPreviewQuestionsByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<RandomPreviewQuestionsByTaskIdQuery, RandomPreviewQuestionsByTaskIdQueryVariables> & ({ variables: RandomPreviewQuestionsByTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RandomPreviewQuestionsByTaskIdQuery, RandomPreviewQuestionsByTaskIdQueryVariables>(RandomPreviewQuestionsByTaskIdDocument, options);
      }
export function useRandomPreviewQuestionsByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RandomPreviewQuestionsByTaskIdQuery, RandomPreviewQuestionsByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RandomPreviewQuestionsByTaskIdQuery, RandomPreviewQuestionsByTaskIdQueryVariables>(RandomPreviewQuestionsByTaskIdDocument, options);
        }
export function useRandomPreviewQuestionsByTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RandomPreviewQuestionsByTaskIdQuery, RandomPreviewQuestionsByTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RandomPreviewQuestionsByTaskIdQuery, RandomPreviewQuestionsByTaskIdQueryVariables>(RandomPreviewQuestionsByTaskIdDocument, options);
        }
export type RandomPreviewQuestionsByTaskIdQueryHookResult = ReturnType<typeof useRandomPreviewQuestionsByTaskIdQuery>;
export type RandomPreviewQuestionsByTaskIdLazyQueryHookResult = ReturnType<typeof useRandomPreviewQuestionsByTaskIdLazyQuery>;
export type RandomPreviewQuestionsByTaskIdSuspenseQueryHookResult = ReturnType<typeof useRandomPreviewQuestionsByTaskIdSuspenseQuery>;
export type RandomPreviewQuestionsByTaskIdQueryResult = Apollo.QueryResult<RandomPreviewQuestionsByTaskIdQuery, RandomPreviewQuestionsByTaskIdQueryVariables>;
export const SendExamCourseCommentDocument = gql`
    mutation sendExamCourseComment($createExamCourseCommentInput: CreateExamCourseCommentInput!) {
  excCreateExamCourseComment(
    CreateExamCourseCommentInput: $createExamCourseCommentInput
  ) {
    comment {
      id
      taskId
      userId
      entityId
      entityType
      content
      createdAt
      updatedAt
    }
  }
}
    `;
export type SendExamCourseCommentMutationFn = Apollo.MutationFunction<SendExamCourseCommentMutation, SendExamCourseCommentMutationVariables>;

/**
 * __useSendExamCourseCommentMutation__
 *
 * To run a mutation, you first call `useSendExamCourseCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendExamCourseCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendExamCourseCommentMutation, { data, loading, error }] = useSendExamCourseCommentMutation({
 *   variables: {
 *      createExamCourseCommentInput: // value for 'createExamCourseCommentInput'
 *   },
 * });
 */
export function useSendExamCourseCommentMutation(baseOptions?: Apollo.MutationHookOptions<SendExamCourseCommentMutation, SendExamCourseCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendExamCourseCommentMutation, SendExamCourseCommentMutationVariables>(SendExamCourseCommentDocument, options);
      }
export type SendExamCourseCommentMutationHookResult = ReturnType<typeof useSendExamCourseCommentMutation>;
export type SendExamCourseCommentMutationResult = Apollo.MutationResult<SendExamCourseCommentMutation>;
export type SendExamCourseCommentMutationOptions = Apollo.BaseMutationOptions<SendExamCourseCommentMutation, SendExamCourseCommentMutationVariables>;
export const ExcUpdateOrCreateExamCourseVerdictDocument = gql`
    mutation ExcUpdateOrCreateExamCourseVerdict($updateOrCreateExamCourseVerdictInput: UpdateOrCreateExamCourseVerdictInput!) {
  excUpdateOrCreateExamCourseVerdict(
    UpdateOrCreateExamCourseVerdictInput: $updateOrCreateExamCourseVerdictInput
  ) {
    verdict {
      verdict
    }
  }
}
    `;
export type ExcUpdateOrCreateExamCourseVerdictMutationFn = Apollo.MutationFunction<ExcUpdateOrCreateExamCourseVerdictMutation, ExcUpdateOrCreateExamCourseVerdictMutationVariables>;

/**
 * __useExcUpdateOrCreateExamCourseVerdictMutation__
 *
 * To run a mutation, you first call `useExcUpdateOrCreateExamCourseVerdictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcUpdateOrCreateExamCourseVerdictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excUpdateOrCreateExamCourseVerdictMutation, { data, loading, error }] = useExcUpdateOrCreateExamCourseVerdictMutation({
 *   variables: {
 *      updateOrCreateExamCourseVerdictInput: // value for 'updateOrCreateExamCourseVerdictInput'
 *   },
 * });
 */
export function useExcUpdateOrCreateExamCourseVerdictMutation(baseOptions?: Apollo.MutationHookOptions<ExcUpdateOrCreateExamCourseVerdictMutation, ExcUpdateOrCreateExamCourseVerdictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcUpdateOrCreateExamCourseVerdictMutation, ExcUpdateOrCreateExamCourseVerdictMutationVariables>(ExcUpdateOrCreateExamCourseVerdictDocument, options);
      }
export type ExcUpdateOrCreateExamCourseVerdictMutationHookResult = ReturnType<typeof useExcUpdateOrCreateExamCourseVerdictMutation>;
export type ExcUpdateOrCreateExamCourseVerdictMutationResult = Apollo.MutationResult<ExcUpdateOrCreateExamCourseVerdictMutation>;
export type ExcUpdateOrCreateExamCourseVerdictMutationOptions = Apollo.BaseMutationOptions<ExcUpdateOrCreateExamCourseVerdictMutation, ExcUpdateOrCreateExamCourseVerdictMutationVariables>;
export const GetExamCourseCommentsDocument = gql`
    query getExamCourseComments($getExamCourseCommentsInput: GetExamCourseCommentsInput!) {
  excGetExamCourseComments(
    GetExamCourseCommentsInput: $getExamCourseCommentsInput
  ) {
    taskId
    entityId
    entityType
    comments {
      id
      taskId
      userId
      entityId
      entityType
      content
      createdAt
      updatedAt
      user {
        firstname
        lastname
        email
        image
      }
    }
  }
}
    `;

/**
 * __useGetExamCourseCommentsQuery__
 *
 * To run a query within a React component, call `useGetExamCourseCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCourseCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCourseCommentsQuery({
 *   variables: {
 *      getExamCourseCommentsInput: // value for 'getExamCourseCommentsInput'
 *   },
 * });
 */
export function useGetExamCourseCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables> & ({ variables: GetExamCourseCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>(GetExamCourseCommentsDocument, options);
      }
export function useGetExamCourseCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>(GetExamCourseCommentsDocument, options);
        }
export function useGetExamCourseCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>(GetExamCourseCommentsDocument, options);
        }
export type GetExamCourseCommentsQueryHookResult = ReturnType<typeof useGetExamCourseCommentsQuery>;
export type GetExamCourseCommentsLazyQueryHookResult = ReturnType<typeof useGetExamCourseCommentsLazyQuery>;
export type GetExamCourseCommentsSuspenseQueryHookResult = ReturnType<typeof useGetExamCourseCommentsSuspenseQuery>;
export type GetExamCourseCommentsQueryResult = Apollo.QueryResult<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>;
export const ExcGetExamCourseVerdictDocument = gql`
    query ExcGetExamCourseVerdict($getExamCourseVerdictInput: GetExamCourseVerdictInput!) {
  excGetExamCourseVerdict(GetExamCourseVerdictInput: $getExamCourseVerdictInput) {
    entityId
    entityType
    taskId
    verdict {
      id
      taskId
      userId
      entityId
      entityType
      verdict
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useExcGetExamCourseVerdictQuery__
 *
 * To run a query within a React component, call `useExcGetExamCourseVerdictQuery` and pass it any options that fit your needs.
 * When your component renders, `useExcGetExamCourseVerdictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExcGetExamCourseVerdictQuery({
 *   variables: {
 *      getExamCourseVerdictInput: // value for 'getExamCourseVerdictInput'
 *   },
 * });
 */
export function useExcGetExamCourseVerdictQuery(baseOptions: Apollo.QueryHookOptions<ExcGetExamCourseVerdictQuery, ExcGetExamCourseVerdictQueryVariables> & ({ variables: ExcGetExamCourseVerdictQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExcGetExamCourseVerdictQuery, ExcGetExamCourseVerdictQueryVariables>(ExcGetExamCourseVerdictDocument, options);
      }
export function useExcGetExamCourseVerdictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExcGetExamCourseVerdictQuery, ExcGetExamCourseVerdictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExcGetExamCourseVerdictQuery, ExcGetExamCourseVerdictQueryVariables>(ExcGetExamCourseVerdictDocument, options);
        }
export function useExcGetExamCourseVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExcGetExamCourseVerdictQuery, ExcGetExamCourseVerdictQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExcGetExamCourseVerdictQuery, ExcGetExamCourseVerdictQueryVariables>(ExcGetExamCourseVerdictDocument, options);
        }
export type ExcGetExamCourseVerdictQueryHookResult = ReturnType<typeof useExcGetExamCourseVerdictQuery>;
export type ExcGetExamCourseVerdictLazyQueryHookResult = ReturnType<typeof useExcGetExamCourseVerdictLazyQuery>;
export type ExcGetExamCourseVerdictSuspenseQueryHookResult = ReturnType<typeof useExcGetExamCourseVerdictSuspenseQuery>;
export type ExcGetExamCourseVerdictQueryResult = Apollo.QueryResult<ExcGetExamCourseVerdictQuery, ExcGetExamCourseVerdictQueryVariables>;
export const ExcGetUploadSignedUrlForExamCourseCommentDocument = gql`
    query ExcGetUploadSignedUrlForExamCourseComment($getUploadSignedUrlForExamCourseCommentInput: GetUploadSignedUrlForExamCourseCommentInput!) {
  excGetUploadSignedUrlForExamCourseComment(
    GetUploadSignedUrlForExamCourseCommentInput: $getUploadSignedUrlForExamCourseCommentInput
  ) {
    signedUrl
    storageObject {
      provider
      bucket
      key
      fileName
    }
  }
}
    `;

/**
 * __useExcGetUploadSignedUrlForExamCourseCommentQuery__
 *
 * To run a query within a React component, call `useExcGetUploadSignedUrlForExamCourseCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useExcGetUploadSignedUrlForExamCourseCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExcGetUploadSignedUrlForExamCourseCommentQuery({
 *   variables: {
 *      getUploadSignedUrlForExamCourseCommentInput: // value for 'getUploadSignedUrlForExamCourseCommentInput'
 *   },
 * });
 */
export function useExcGetUploadSignedUrlForExamCourseCommentQuery(baseOptions: Apollo.QueryHookOptions<ExcGetUploadSignedUrlForExamCourseCommentQuery, ExcGetUploadSignedUrlForExamCourseCommentQueryVariables> & ({ variables: ExcGetUploadSignedUrlForExamCourseCommentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExcGetUploadSignedUrlForExamCourseCommentQuery, ExcGetUploadSignedUrlForExamCourseCommentQueryVariables>(ExcGetUploadSignedUrlForExamCourseCommentDocument, options);
      }
export function useExcGetUploadSignedUrlForExamCourseCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExcGetUploadSignedUrlForExamCourseCommentQuery, ExcGetUploadSignedUrlForExamCourseCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExcGetUploadSignedUrlForExamCourseCommentQuery, ExcGetUploadSignedUrlForExamCourseCommentQueryVariables>(ExcGetUploadSignedUrlForExamCourseCommentDocument, options);
        }
export function useExcGetUploadSignedUrlForExamCourseCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExcGetUploadSignedUrlForExamCourseCommentQuery, ExcGetUploadSignedUrlForExamCourseCommentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExcGetUploadSignedUrlForExamCourseCommentQuery, ExcGetUploadSignedUrlForExamCourseCommentQueryVariables>(ExcGetUploadSignedUrlForExamCourseCommentDocument, options);
        }
export type ExcGetUploadSignedUrlForExamCourseCommentQueryHookResult = ReturnType<typeof useExcGetUploadSignedUrlForExamCourseCommentQuery>;
export type ExcGetUploadSignedUrlForExamCourseCommentLazyQueryHookResult = ReturnType<typeof useExcGetUploadSignedUrlForExamCourseCommentLazyQuery>;
export type ExcGetUploadSignedUrlForExamCourseCommentSuspenseQueryHookResult = ReturnType<typeof useExcGetUploadSignedUrlForExamCourseCommentSuspenseQuery>;
export type ExcGetUploadSignedUrlForExamCourseCommentQueryResult = Apollo.QueryResult<ExcGetUploadSignedUrlForExamCourseCommentQuery, ExcGetUploadSignedUrlForExamCourseCommentQueryVariables>;
export const ExcGetDownloadSignedUrlForExamCourseCommentDocument = gql`
    query ExcGetDownloadSignedUrlForExamCourseComment($getDownloadSignedUrlForExamCourseCommentInput: GetDownloadSignedUrlForExamCourseCommentInput!) {
  excGetDownloadSignedUrlForExamCourseComment(
    GetDownloadSignedUrlForExamCourseCommentInput: $getDownloadSignedUrlForExamCourseCommentInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useExcGetDownloadSignedUrlForExamCourseCommentQuery__
 *
 * To run a query within a React component, call `useExcGetDownloadSignedUrlForExamCourseCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useExcGetDownloadSignedUrlForExamCourseCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExcGetDownloadSignedUrlForExamCourseCommentQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamCourseCommentInput: // value for 'getDownloadSignedUrlForExamCourseCommentInput'
 *   },
 * });
 */
export function useExcGetDownloadSignedUrlForExamCourseCommentQuery(baseOptions: Apollo.QueryHookOptions<ExcGetDownloadSignedUrlForExamCourseCommentQuery, ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables> & ({ variables: ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExcGetDownloadSignedUrlForExamCourseCommentQuery, ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables>(ExcGetDownloadSignedUrlForExamCourseCommentDocument, options);
      }
export function useExcGetDownloadSignedUrlForExamCourseCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExcGetDownloadSignedUrlForExamCourseCommentQuery, ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExcGetDownloadSignedUrlForExamCourseCommentQuery, ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables>(ExcGetDownloadSignedUrlForExamCourseCommentDocument, options);
        }
export function useExcGetDownloadSignedUrlForExamCourseCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExcGetDownloadSignedUrlForExamCourseCommentQuery, ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExcGetDownloadSignedUrlForExamCourseCommentQuery, ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables>(ExcGetDownloadSignedUrlForExamCourseCommentDocument, options);
        }
export type ExcGetDownloadSignedUrlForExamCourseCommentQueryHookResult = ReturnType<typeof useExcGetDownloadSignedUrlForExamCourseCommentQuery>;
export type ExcGetDownloadSignedUrlForExamCourseCommentLazyQueryHookResult = ReturnType<typeof useExcGetDownloadSignedUrlForExamCourseCommentLazyQuery>;
export type ExcGetDownloadSignedUrlForExamCourseCommentSuspenseQueryHookResult = ReturnType<typeof useExcGetDownloadSignedUrlForExamCourseCommentSuspenseQuery>;
export type ExcGetDownloadSignedUrlForExamCourseCommentQueryResult = Apollo.QueryResult<ExcGetDownloadSignedUrlForExamCourseCommentQuery, ExcGetDownloadSignedUrlForExamCourseCommentQueryVariables>;
export const GetPreviewTaskReviewRolesDocument = gql`
    query getPreviewTaskReviewRoles($getTaskByIdInput: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $getTaskByIdInput) {
    task {
      id
      assignerId
      assignee {
        id
      }
      parentTask {
        ownerId
      }
      currentWorkflowStep {
        code
      }
    }
  }
}
    `;

/**
 * __useGetPreviewTaskReviewRolesQuery__
 *
 * To run a query within a React component, call `useGetPreviewTaskReviewRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewTaskReviewRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewTaskReviewRolesQuery({
 *   variables: {
 *      getTaskByIdInput: // value for 'getTaskByIdInput'
 *   },
 * });
 */
export function useGetPreviewTaskReviewRolesQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewTaskReviewRolesQuery, GetPreviewTaskReviewRolesQueryVariables> & ({ variables: GetPreviewTaskReviewRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewTaskReviewRolesQuery, GetPreviewTaskReviewRolesQueryVariables>(GetPreviewTaskReviewRolesDocument, options);
      }
export function useGetPreviewTaskReviewRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewTaskReviewRolesQuery, GetPreviewTaskReviewRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewTaskReviewRolesQuery, GetPreviewTaskReviewRolesQueryVariables>(GetPreviewTaskReviewRolesDocument, options);
        }
export function useGetPreviewTaskReviewRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewTaskReviewRolesQuery, GetPreviewTaskReviewRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviewTaskReviewRolesQuery, GetPreviewTaskReviewRolesQueryVariables>(GetPreviewTaskReviewRolesDocument, options);
        }
export type GetPreviewTaskReviewRolesQueryHookResult = ReturnType<typeof useGetPreviewTaskReviewRolesQuery>;
export type GetPreviewTaskReviewRolesLazyQueryHookResult = ReturnType<typeof useGetPreviewTaskReviewRolesLazyQuery>;
export type GetPreviewTaskReviewRolesSuspenseQueryHookResult = ReturnType<typeof useGetPreviewTaskReviewRolesSuspenseQuery>;
export type GetPreviewTaskReviewRolesQueryResult = Apollo.QueryResult<GetPreviewTaskReviewRolesQuery, GetPreviewTaskReviewRolesQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "QConfigStructureCondition": [
      "QConfigStructureConditionMultiTagGroup",
      "QConfigStructureConditionSingleTagGroup"
    ],
    "QConfigStructureConditionObjectType": [
      "QConfigStructureConditionMultiTagGroupObjectType",
      "QConfigStructureConditionSingleTagGroupObjectType"
    ],
    "TaskMetadata": [
      "TaskMetadataWithAdditionalData",
      "TaskMetadataWithExamCourse",
      "TaskMetadataWithQSet",
      "TaskMetadataWithQuestionCreation",
      "TaskMetadataWithQuestionReviewed",
      "TaskMetadataWithReviewQuestion"
    ]
  }
};
      export default result;
    